import React, { useState, useEffect } from "react";
import { Field, FormSpy, Form } from "react-final-form";
import validatePage1 from "../../utils/validatePage1";
import validatePage2 from "../../utils/validatePage2";
import validatePage3 from "../../utils/validatePage3";
import validatePage4 from "../../utils/validatePage4";
import validatePage5 from "../../utils/validatePage5";
import validatePage6 from "../../utils/validatePage6";
import direcciónZonaUrbana from "../../utils/direcciónZonaUrbana";
import SelectAsyncPaginateLocalidades from "./SelectAsyncPaginateLocalidades";
import SelectAsyncPaginateBarrios from "./SelectAsyncPaginateBarrios";
import SelectAsyncPaginateMunicipios from "./SelectAsyncPaginateMunicipios";
import SelectAsyncPaginateDepartamento from "./SelectAsyncPaginateDepartamentos";
import SelectAsyncPaginateDepartamentoBogota from "./SelectAsyncPaginateDepartamentoBogota";
import SelectAsyncPaginateMunicipiosBogota from "./SelectAsyncPaginateMunicipiosBogota";
import { getAllStep } from "@Utils";
import FileField from "../../components/form/fileField";
import Wizard from "./Wizard";
import "../../styles/BepsForm.css";
import SelectAsyncUstedEs from "../SelectAsync/SelectAsyncUstedEs";
import SelectAsyncGrupoEt from "../SelectAsync/SelectAsyncGrupoEt";
import SelectAsyncGenero  from "../SelectAsync/SelectAsyncGenero";
import SelectAsyncResiden from "../SelectAsync/SelectAsyncRedicen";
import SelectAsyncTipoIdenti from "../SelectAsync/SelectAsyncTipoIdenti";
import SelectAsyncSiNo from "../SelectAsync/SelectAsyncSiNo";
import SelectAsyncEstrato from "../SelectAsync/SelectAsyncEstrato";
import SelectAsyncAfiliado from "../SelectAsync/SelectAsyncAfiliado";
import SelectAsyncDiscapacidad from "../SelectAsync/SelectAsyncDiscapacidad";
import SelectAsyncArea from "../SelectAsync/SelectAsyncArea";
import SelectAsyncNivelEdu from "../SelectAsync/SelectAsyncNivelEdu";
import SelectAsyncAreasArt from "../SelectAsync/SelectAsyncAreasArt";
import SelectAsyncSexo from "../SelectAsync/SelectAsyncSexo";
import SelectAsyncComunidad from "../SelectAsync/SelectAsyncComunidad";
import SelectAsyncPuntajeSisben from "../SelectAsync/SelectPuntajeSisben";
import SelectAsyncCensal from "../SelectAsync/SelectAsyncCensal";
import SelectAsyncIngresos from "../SelectAsync/SelectAsyncIngresos";
import SelectAsyncSector from "../SelectAsync/SelectAsyncSector";
import { getFormPages } from "../../services/sendFormPages/sendFormPages";
import SelectAsyncTipoContrato from "../SelectAsync/SelectAsyncTipoContrato";
import SelectAsyncAgremiacion from "../SelectAsync/SelectAsyncAgremiacion";
import {
    downloadFile,
    fileToBase64,
} from "../../services/sendFormPages/sendForm";

const BepsForm = () => {
    const [idLocalidad, setIdLocalidad] = useState();
    const [idDepartamento, setIdDepartamento] = useState();
    const [idDepartamentoResi, setIdDepartamentoResi] = useState();
    const [idGrupoEt, setIdGrupoEt] = useState();
    const [idEstado, setIdEstado] = useState();
    const [municipios, setMunicipios] = useState(null);
    const [municipiosResi, setMunicipiosResi] = useState(null);
    const [idSisben, setIdSisben] = useState();
    const [idCencial, setIdCencial] = useState();
    const [idAgremiacion, setIdAgremiacion] = useState();
    const [idContri, setIdContri] = useState();
    const [idDiscapacidad, setIdDiscapacidad] = useState();
    const [selectedDiscapacidad, setSelectedDiscapacidad] = useState();
    const [idArea, setIdArea] = useState();
    const [siNo, setSiNo] = useState();
    const [formacionArt, setformacionArt] = useState();
    const [expArt, setExpArt] = useState();
    const [idComunidad, setIdComunidad] = useState();
    const [idOtro, setIdOtro] = useState();
    const [salar, setSala] = useState();
    const [dataForm, setDataForm] = useState({});
    const [tipoAgremiacion, setTipoAgremiacion] = useState();
    const [pageOneCompleted, setPageOneCompleted] = useState(false);
    const [stepFive, setStepFive] = useState({});
    const [show, setShow] = useState(false);
    const [url, setUrl] = useState("");
    const [lastStep, setLastStep] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [showAddress, setShowAddress] = useState(false);

    const chargeData = async () => {
        const isLastest = localStorage.getItem("ultimo_paso");
        if (parseInt(isLastest) > 5) {
            await getAllStep();
            setStepFive(JSON.parse(localStorage.getItem("dataLastStep")));
        }
    };

    useEffect(() => {
        chargeData();
    }, []);

    const pageChanged = async (currentPage) => {
        const lastStep = localStorage.ultimo_paso;
        setLastStep(currentPage == 6);
        const document = localStorage.documento;
        setPageOneCompleted(lastStep > 1);
        const data = await getFormPages(document, currentPage);
        if (data === false) {
            localStorage.setItem("isEdit", false);
        } else if (Object.values(data).every((valor) => valor === undefined)) {
            localStorage.setItem("isEdit", false);
        } else {
            localStorage.setItem("isEdit", true);
            setShowAddress(true);
            setIsEdit(true);
        }
        localStorage.setItem("dataCurrentPage", JSON.stringify(data));
        setDataForm(data);
    };

    const stylesSelect = (meta) => {
        return {
            control: (baseStyles) => ({
                ...baseStyles,
                outline:
                    meta.error && meta.touched ? "1px solid #FF0000" : "null",
            }),
        };
    };
    const Condition = ({ when, is, children }) => (
        <Field name={when} subscription={{ value: true }}>
            {({ input: { value } }) => (value === is ? children : null)}
        </Field>
    );

    const selectLocalidad = ({ input, meta, ...rest }) => (
        <div>
            <SelectAsyncPaginateLocalidades
                id={dataForm?.residencia?.localidad}
                {...input}
                {...rest}
                {...meta}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </div>
    );
    const selectUstedEs = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncUstedEs
                id={dataForm?.datos_personales?.usted}
                {...input}
                {...rest}
                {...meta}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );

    const selectGenero = ({ input, meta, ...rest}) => (
        <>
            <SelectAsyncGenero
                id={dataForm?.datos_personales?.genero}
                {...input}
                {...rest}
                {...meta}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>


    )

    const selectResiden = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncResiden
                id={dataForm?.nivel_socioeconomico?.con_quien_reside}
                {...input}
                {...rest}
                {...meta}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectGrupoEt = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncGrupoEt
                id={dataForm?.persona?.grupo_etnico}
                {...input}
                {...rest}
                {...meta}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );

    const selectEstrato = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncEstrato
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.nivel_socioeconomico?.estrato}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectAfiliado = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncAfiliado
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.sistema_salud?.forma_afiliacion_salud}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectDiscapacidad = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncDiscapacidad
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.sistema_salud?.tipo_discapacidad}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectCensal = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncCensal
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.nivel_socioeconomico?.cual_listado_censal}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectPuntajeSisben = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncPuntajeSisben
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.nivel_socioeconomico?.indique_puntaje_sisben}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectArea = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncArea
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.residencia?.area}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectTipoDo = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncTipoIdenti
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.persona?.tipo_documento}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectTipoAgremiacion = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncAgremiacion
                {...input}
                {...rest}
                {...meta}
                styles={{
                    control: (baseStyles) => ({
                        ...baseStyles,
                        outline:
                            meta.error && meta.touched
                                ? "1px solid #FF0000"
                                : "null",
                    }),
                }}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectSexo = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncSexo
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.persona?.sexo}
                styles={{
                    control: (baseStyles) => ({
                        ...baseStyles,
                        outline:
                            meta.error && meta.touched
                                ? "1px solid #FF0000"
                                : "null",
                    }),
                }}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectComunidad = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncComunidad
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.persona?.etnia_indigena}
                styles={{
                    control: (baseStyles) => ({
                        ...baseStyles,
                        outline:
                            meta.error && meta.touched
                                ? "1px solid #FF0000"
                                : "null",
                    }),
                }}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectTipoContrato = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncTipoContrato
                {...input}
                {...rest}
                {...meta}
                styles={{
                    control: (baseStyles) => ({
                        ...baseStyles,
                        outline:
                            meta.error && meta.touched
                                ? "1px solid #FF0000"
                                : "null",
                    }),
                }}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const SelectBarrios = ({ input, meta, ...rest }) => {
        return (
            <div>
                <SelectAsyncPaginateBarrios
                    localidad={idLocalidad?.id}
                    {...input}
                    {...rest}
                    {...meta}
                    id={dataForm?.residencia?.barrio}
                    styles={{
                        control: (baseStyles) => ({
                            ...baseStyles,
                            outline:
                                meta.error && meta.touched
                                    ? "1px solid #FF0000"
                                    : "null",
                        }),
                    }}
                />
                <small className="error-message">
                    {" "}
                    {meta.error && meta.touched && (
                        <span>{meta.error}</span>
                    )}{" "}
                </small>
            </div>
        );
    };
    const selectDepartamento = ({ input, meta, ...rest }) => (
        <div>
            <SelectAsyncPaginateDepartamento
                departamento={dataForm?.persona?.municipio_nacimiento}
                {...input}
                {...rest}
                {...meta}
                styles={{
                    control: (baseStyles) => ({
                        ...baseStyles,
                        outline:
                            meta.error && meta.touched
                                ? "1px solid #FF0000"
                                : "null",
                    }),
                }}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </div>
    );
    const selectDepartamentoBogota = ({ input, meta, ...rest }) => (
        <div>
            <SelectAsyncPaginateDepartamentoBogota
                {...input}
                {...rest}
                {...meta}
                styles={{
                    control: (baseStyles) => ({
                        ...baseStyles,
                        outline:
                            meta.error && meta.touched
                                ? "1px solid #FF0000"
                                : "null",
                    }),
                }}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </div>
    );
    const selectMunicipiosResi = ({ input, meta, ...rest }) => (
        <div>
            <SelectAsyncPaginateMunicipiosBogota
                departamento={idDepartamentoResi?.id}
                value={municipiosResi?.nombre}
                onChange={(municipio) =>
                    !municipios && setMunicipiosResi(municipiosResi)
                }
                {...input}
                {...rest}
                {...meta}
                styles={{
                    control: (baseStyles) => ({
                        ...baseStyles,
                        outline:
                            meta.error && meta.touched
                                ? "1px solid #FF0000"
                                : "null",
                    }),
                }}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </div>
    );
    const selectMunicipios = ({ input, meta, ...rest }) => (
        <div>
            <SelectAsyncPaginateMunicipios
                departamento={idDepartamento?.id}
                idMun={dataForm?.persona?.municipio_nacimiento}
                value={municipios?.nombre}
                onChange={(municipio) =>
                    !municipios && setMunicipios(municipio)
                }
                {...input}
                {...rest}
                {...meta}
                styles={{
                    control: (baseStyles) => ({
                        ...baseStyles,
                        outline:
                            meta.error && meta.touched
                                ? "1px solid #FF0000"
                                : "null",
                    }),
                }}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </div>
    );
    const selectSiNo = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncSiNo
                {...input}
                {...rest}
                {...meta}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectIngresos = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncIngresos
                {...input}
                {...rest}
                {...meta}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectNivelEdu = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncNivelEdu
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.formaciones?.nivel_educativo_alcanzado}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectAreasArt = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncAreasArt
                {...input}
                {...rest}
                {...meta}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const selectSector = ({ input, meta, ...rest }) => (
        <>
            <SelectAsyncSector
                {...input}
                {...rest}
                {...meta}
                id={dataForm?.datos_personales?.sector}
                styles={stylesSelect(meta)}
            />
            <small className="error-message">
                {" "}
                {meta.error && meta.touched && <span>{meta.error}</span>}{" "}
            </small>
        </>
    );
    const onSubmit = async (values) => {};

    const showModal = async (obj) => {
        const fileUrl = !(obj instanceof File)
            ? obj.url
            : URL.createObjectURL(obj);

        window.open(fileUrl, '_blank');

        setTimeout(() => {
            URL.revokeObjectURL(fileUrl);
        }, 60000); 
    };
    const handleClose = () => {
        setShow(false);
        setUrl("");
    };

    const showAddressEvent = () => {
        setShowAddress(!showAddress);
    };

    return (
        <>
            <h3 className="mt-5">
                A continuación completa tus datos para procesar tu solicitud
            </h3>
            <p className="mb-2">Los campos en asterisco (*) son obligatorios</p>
            {lastStep ? (
                <p className="mb-4">
                    Solo se permite adjuntar documentos en formato pdf.
                </p>
            ) : (
                ""
            )}
            <Form
                onSubmit={onSubmit}
                render={({ handleSubmit }) => (
                    <Wizard onPageChange={pageChanged} onSubmit={onSubmit}>
                        {/* Page 1 */}
                        <Wizard.Page
                            validate={(values) =>
                                validatePage1(values, showAddress, isEdit)
                            }
                        >
                            <div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <label htmlFor="tipoGestor">
                                            Usted se define como:*
                                        </label>
                                        <Field
                                            name="tipoGestor"
                                            defaultValue={
                                                dataForm?.persona
                                                    ?.datos_personales
                                            }
                                            component={selectUstedEs}
                                            className="react-select"
                                        ></Field>
                                    </div>

                                    <div className="text-center col-lg-12 mb-3">
                                        <b>Datos personales</b>
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            name="primerNombre"
                                            defaultValue={
                                                dataForm?.persona?.primer_nombre
                                            }
                                        >
                                            {({input, meta}) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="primerNombre">
                                                        Primer nombre:*
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="primerNombre"
                                                        id="primerNombre"
                                                        className={
                                                            meta.error &&
                                                            meta.touched
                                                                ? "w-100 invalid"
                                                                : "w-100"
                                                        }
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            name="segundoNombre"
                                            defaultValue={
                                                dataForm?.persona
                                                    ?.segundo_nombre
                                            }
                                        >
                                            {({input, meta}) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="segundoNombre">
                                                        Segundo nombre:{" "}
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="segundoNombre"
                                                        id="segundoNombre"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.persona
                                                    ?.primer_apellido
                                            }
                                            name="primerApellido"
                                        >
                                            {({input, meta}) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="primerApellido">
                                                        Primer apellido*:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="primerApellido"
                                                        id="primerApellido"
                                                        className={
                                                            meta.error &&
                                                            meta.touched
                                                                ? "w-100 invalid"
                                                                : "w-100"
                                                        }
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.persona
                                                    ?.segundo_apellido
                                            }
                                            name="segundoApellido"
                                        >
                                            {({input, meta}) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="segundoApellido">
                                                        Segundo apellido:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="segundoApellido"
                                                        id="segundoApellido"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="tipoIdentificación">
                                            Tipo de identificación:*
                                        </label>
                                        <Field
                                            className="react-select"
                                            name="tipoIdentificación"
                                            component={selectTipoDo}
                                        />
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.persona
                                                    ?.numero_documento
                                            }
                                            name="numeroIdentificación"
                                        >
                                            {({input, meta}) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="numeroIdentificación">
                                                        Número de
                                                        identificación:*
                                                    </label>
                                                    <input
                                                        {...input}
                                                        disabled={
                                                            pageOneCompleted
                                                        }
                                                        type="number"
                                                        name="numeroIdentificación"
                                                        id="numeroIdentificación"
                                                        className={
                                                            meta.error &&
                                                            meta.touched
                                                                ? "w-100 invalid"
                                                                : "w-100"
                                                        }
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.persona
                                                    ?.fecha_expedicion
                                            }
                                            name="expediciónCédula"
                                        >
                                            {({input, meta}) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="expediciónCédula">
                                                        Fecha expedición
                                                        cédula:*{" "}
                                                    </label>
                                                    <input
                                                        {...input}
                                                        disabled={
                                                            pageOneCompleted
                                                        }
                                                        type="date"
                                                        name="expediciónCédula"
                                                        id="expediciónCédula"
                                                        className={
                                                            meta.error &&
                                                            meta.touched
                                                                ? "w-100 invalid"
                                                                : "w-100"
                                                        }
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}{" "}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="sexo">Sexo al nacer:*</label>
                                        <Field
                                            name="sexo"
                                            id="sexo"
                                            component={selectSexo}
                                        />
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="genero">Genero:*</label>
                                        <Field
                                            name="genero"
                                            id="genero"
                                            component={selectGenero}
                                        />
                                    </div>

                                    <Field name="genero" subscription={{value: true}}>
                                        {({input: generoInput}) =>
                                            generoInput.value?.id === 1024 ? (
                                                <div className="col-lg-6">
                                                    <Field name="genero_otro">
                                                        {({input, meta}) => (
                                                            <div className="form-group gov-co-form-group w-100">
                                                                {/* 1) htmlFor coincide con el id del input */}
                                                                <label htmlFor="genero_otro">Especifique otro
                                                                    género:*</label>
                                                                <input
                                                                    {...input}
                                                                    id="genero_otro"             // 2) ponemos el id aquí
                                                                    type="text"
                                                                    className={
                                                                        meta.error && meta.touched
                                                                            ? "w-100 invalid"
                                                                            : "w-100"
                                                                    }
                                                                    placeholder="¿Cuál?"
                                                                />
                                                                <small className="error-message form-text">
                                                                    {meta.error && meta.touched && meta.error}
                                                                </small>
                                                            </div>
                                                        )}
                                                    </Field>
                                                </div>
                                            ) : null
                                        }
                                    </Field>

                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.persona
                                                    ?.fecha_nacimiento
                                            }
                                            name="fechaNacimiento"
                                        >
                                            {({input, meta}) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="fechaNacimiento">
                                                        Fecha de nacimiento:*{" "}
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="date"
                                                        name="fechaNacimiento"
                                                        id="fechaNacimiento"
                                                        className={
                                                            meta.error &&
                                                            meta.touched
                                                                ? "w-100 invalid"
                                                                : "w-100"
                                                        }
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}{" "}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="departamentoNacimiento">
                                            Departamento de nacimiento:*{" "}
                                        </label>
                                        <Field
                                            name="departamentoNacimiento"
                                            component={selectDepartamento}
                                        ></Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="municipioNacimiento">
                                            Municipio de nacimiento:*{" "}
                                        </label>
                                        <Field
                                            name="municipioNacimiento"
                                            component={selectMunicipios}
                                        ></Field>
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="grupoÉtnico">
                                            Grupo étnico:*{" "}
                                        </label>
                                        <Field
                                            name="grupoÉtnico"
                                            component={selectGrupoEt}
                                        ></Field>
                                    </div>
                                    {idGrupoEt?.id === 301 && (
                                        <>
                                            <div className="col-lg-12">
                                                <label htmlFor="comunidadIndígena">
                                                    ¿Cuál comunidad indígena?:*
                                                </label>
                                                <Field
                                                    id="comunidadIndígena"
                                                    name="comunidadIndígena"
                                                    component={selectComunidad}
                                                />
                                            </div>
                                            {idComunidad?.id === 27 && (
                                                <>
                                                    <Field
                                                        defaultValue={
                                                            dataForm?.persona
                                                                ?.otra_etnia_indigena
                                                        }
                                                        name="cualComunidadIndígena"
                                                    >
                                                        {({input, meta}) => (
                                                            <div
                                                                className="col-lg-12 form-group gov-co-form-group w-100">
                                                                <label htmlFor="cualComunidadIndígena">
                                                                    Indique cuál
                                                                    comunidad
                                                                    indígena:*
                                                                </label>
                                                                <input
                                                                    {...input}
                                                                    type="text"
                                                                    name="cualComunidadIndígena"
                                                                    id="cualComunidadIndígena"
                                                                    className={
                                                                        meta.error &&
                                                                        meta.touched
                                                                            ? "w-100 invalid"
                                                                            : "w-100"
                                                                    }
                                                                ></input>
                                                                <small className="error-message form-text">
                                                                    {" "}
                                                                    {meta.error &&
                                                                        meta.touched && (
                                                                            <span>
                                                                                {
                                                                                    meta.error
                                                                                }
                                                                            </span>
                                                                        )}
                                                                </small>
                                                            </div>
                                                        )}
                                                    </Field>
                                                </>
                                            )}
                                        </>
                                    )}
                                    <div className="col">
                                        <label htmlFor="sector">
                                            Sector:*{" "}
                                        </label>
                                        <Field
                                            name="sector"
                                            component={selectSector}
                                        ></Field>
                                    </div>
                                    <div className="text-center col-lg-12 mt-3 mb-3">
                                        <b>Residencia actual </b>
                                        <p>
                                            Nota: si usted reside en una ciudad
                                            o municipio diferente a Bogotá debe
                                            adelantar su proceso de aplicación
                                            en dicho lugar
                                        </p>
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="departamentoResidencia">
                                            Departamento de residencia:*
                                        </label>
                                        <Field
                                            id="departamentoResidencia"
                                            name="departamentoResidencia"
                                            component={selectDepartamentoBogota}
                                        ></Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="municipioResidencia">
                                            Municipio de residencia:*
                                        </label>
                                        <Field
                                            id="municipioResidencia"
                                            name="municipioResidencia"
                                            component={selectMunicipiosResi}
                                        ></Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.residencia
                                                    ?.tiempo_residencia_anos
                                            }
                                            name="tiempoResidencia"
                                        >
                                            {({input, meta}) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="tiempoResidencia">
                                                        Tiempo de residencia en
                                                        Bogotá (Años):*
                                                    </label>
                                                    <input
                                                        {...input}
                                                        min="1"
                                                        max="100"
                                                        type="number"
                                                        name="tiempoResidencia"
                                                        id="tiempoResidencia"
                                                        className={
                                                            meta.error &&
                                                            meta.touched
                                                                ? "w-100 invalid"
                                                                : "w-100"
                                                        }
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="zona">Zona:*</label>
                                        <Field
                                            name="zona"
                                            id="zona"
                                            component={selectArea}
                                        />
                                    </div>

                                    <div className="col-lg-6 mb-3">
                                        <label>Localidad:* </label>
                                        <Field
                                            name="localidad"
                                            component={selectLocalidad}
                                        />
                                    </div>
                                    {idArea?.id === 223 ? (
                                        <>
                                            <div className="col-lg-6">
                                                <Field
                                                    defaultValue={
                                                        dataForm?.residencia
                                                            ?.direccion
                                                    }
                                                    name="direcciónZonaRural"
                                                >
                                                    {({input, meta}) => (
                                                        <div className="form-group gov-co-form-group w-100">
                                                            <label htmlFor="direcciónZonaRural">
                                                                Dirección zona
                                                                rural:*
                                                            </label>
                                                            <input
                                                                {...input}
                                                                type="text"
                                                                name="direcciónZonaRural"
                                                                id="direcciónZonaRural"
                                                                className={
                                                                    meta.error &&
                                                                    meta.touched
                                                                        ? "w-100 invalid"
                                                                        : "w-100"
                                                                }
                                                            ></input>
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </div>
                                                    )}
                                                </Field>
                                            </div>
                                        </>
                                    ) : (
                                        idArea?.id === 224 && (
                                            <>
                                                <div className="col-lg-6">
                                                    <label>Barrio:*</label>
                                                    <Field
                                                        name="barrio"
                                                        component={
                                                            SelectBarrios
                                                        }
                                                    />
                                                </div>
                                                {!showAddress ? (
                                                    <>
                                                        <div className="col-4">
                                                            <Field name="via">
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="via">
                                                                            Via:*
                                                                        </label>
                                                                        <select
                                                                            {...input}
                                                                            name="via"
                                                                            id="via"
                                                                            className={
                                                                                meta.error &&
                                                                                meta.touched
                                                                                    ? "w-100 invalid"
                                                                                    : "w-100"
                                                                            }
                                                                        >
                                                                            <option value="">
                                                                                Seleccionar
                                                                            </option>
                                                                            <option value="CL">
                                                                                Calle
                                                                            </option>
                                                                            <option value="KR">
                                                                                Carrera
                                                                            </option>
                                                                            <option value="AV">
                                                                                Avenida
                                                                            </option>
                                                                            <option value="AK">
                                                                                Avenida
                                                                                Carrera
                                                                            </option>
                                                                            <option value="AC">
                                                                                Avenida
                                                                                Calle
                                                                            </option>
                                                                            <option value="AU">
                                                                                Autopista
                                                                            </option>
                                                                            <option value="DG">
                                                                                Diagonal
                                                                            </option>
                                                                            <option value="TV">
                                                                                Transversal
                                                                            </option>
                                                                            <option value="AVIAL">
                                                                                Anillo
                                                                                Vial
                                                                            </option>
                                                                            <option value="CIR">
                                                                                Circular
                                                                            </option>
                                                                            <option value="CLJ">
                                                                                Callejón
                                                                            </option>
                                                                        </select>
                                                                        <small className="error-message form-text">
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <div className="col-4">
                                                            <Field name="numeroVia">
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="numeroVia">
                                                                            Número:*
                                                                        </label>
                                                                        <input
                                                                            {...input}
                                                                            type="number"
                                                                            min="1"
                                                                            name="numeroVia"
                                                                            id="numeroVia"
                                                                            className={
                                                                                meta.error &&
                                                                                meta.touched
                                                                                    ? "w-100 invalid"
                                                                                    : "w-100"
                                                                            }
                                                                        ></input>
                                                                        <small className="error-message form-text">
                                                                            {" "}
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <div className="col-4">
                                                            <Field name="letra">
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="via">
                                                                            Letra:
                                                                        </label>
                                                                        <select
                                                                            {...input}
                                                                            name="letra"
                                                                            id="letra"
                                                                            className="w-100"
                                                                        >
                                                                            <option value="">
                                                                                Seleccionar
                                                                            </option>
                                                                            <option value="A">
                                                                                A
                                                                            </option>
                                                                            <option value="B">
                                                                                B
                                                                            </option>
                                                                            <option value="C">
                                                                                C
                                                                            </option>
                                                                            <option value="D">
                                                                                D
                                                                            </option>
                                                                            <option value="E">
                                                                                E
                                                                            </option>
                                                                            <option value="F">
                                                                                F
                                                                            </option>
                                                                            <option value="G">
                                                                                G
                                                                            </option>
                                                                            <option value="H">
                                                                                H
                                                                            </option>
                                                                            <option value="I">
                                                                                I
                                                                            </option>
                                                                            <option value="J">
                                                                                J
                                                                            </option>
                                                                            <option value="K">
                                                                                K
                                                                            </option>
                                                                            <option value="L">
                                                                                L
                                                                            </option>
                                                                            <option value="M">
                                                                                M
                                                                            </option>
                                                                            <option value="N">
                                                                                N
                                                                            </option>
                                                                            <option value="O">
                                                                                O
                                                                            </option>
                                                                            <option value="P">
                                                                                P
                                                                            </option>
                                                                            <option value="Q">
                                                                                Q
                                                                            </option>
                                                                            <option value="R">
                                                                                R
                                                                            </option>
                                                                            <option value="S">
                                                                                S
                                                                            </option>
                                                                            <option value="T">
                                                                                T
                                                                            </option>
                                                                            <option value="U">
                                                                                U
                                                                            </option>
                                                                            <option value="V">
                                                                                V
                                                                            </option>
                                                                            <option value="W">
                                                                                W
                                                                            </option>
                                                                            <option value="X">
                                                                                X
                                                                            </option>
                                                                            <option value="Y">
                                                                                Y
                                                                            </option>
                                                                            <option value="Z">
                                                                                Z
                                                                            </option>
                                                                        </select>
                                                                        <small className="error-message form-text">
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <div className="col-4">
                                                            <Field
                                                                name="bis"
                                                                type="checkbox"
                                                            >
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="bis">
                                                                            Bis?:
                                                                        </label>
                                                                        <input
                                                                            {...input}
                                                                            type="checkbox"
                                                                            name="bis"
                                                                            id="bis"
                                                                            className="w-100"
                                                                        ></input>
                                                                        <small className="error-message form-text">
                                                                            {" "}
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <div className="col-4">
                                                            <Field name="sectorAddress">
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="sectorAddress">
                                                                            Orientación:
                                                                        </label>
                                                                        <select
                                                                            {...input}
                                                                            name="sectorAddress"
                                                                            id="sectorAddress"
                                                                            className="w-100"
                                                                        >
                                                                            <option value="">
                                                                                Seleccionar
                                                                            </option>
                                                                            <option value="Norte">
                                                                                Norte
                                                                            </option>
                                                                            <option value="Sur">
                                                                                Sur
                                                                            </option>
                                                                            <option value="Este">
                                                                                Este
                                                                            </option>
                                                                            <option value="Oeste">
                                                                                Oeste
                                                                            </option>
                                                                        </select>
                                                                        <small className="error-message form-text">
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>

                                                        <div className="col-4">
                                                            <Field name="numeroViaSecun">
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="numeroViaSecun">
                                                                            Número
                                                                            vía
                                                                            secundaria:*
                                                                        </label>
                                                                        <input
                                                                            {...input}
                                                                            type="text"
                                                                            name="numeroViaSecun"
                                                                            id="numeroViaSecun"
                                                                            className={
                                                                                meta.error &&
                                                                                meta.touched
                                                                                    ? "w-100 invalid"
                                                                                    : "w-100"
                                                                            }
                                                                        ></input>
                                                                        <small className="error-message form-text">
                                                                            {" "}
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <div className="col-4">
                                                            <Field name="letraSecun">
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="letraSecun">
                                                                            Letra:
                                                                        </label>
                                                                        <select
                                                                            {...input}
                                                                            name="letraSecun"
                                                                            id="letraSecun"
                                                                            className="w-100"
                                                                        >
                                                                            <option value="">
                                                                                Seleccionar
                                                                            </option>
                                                                            <option value="A">
                                                                                A
                                                                            </option>
                                                                            <option value="B">
                                                                                B
                                                                            </option>
                                                                            <option value="C">
                                                                                C
                                                                            </option>
                                                                            <option value="D">
                                                                                D
                                                                            </option>
                                                                            <option value="E">
                                                                                E
                                                                            </option>
                                                                            <option value="F">
                                                                                F
                                                                            </option>
                                                                            <option value="G">
                                                                                G
                                                                            </option>
                                                                            <option value="H">
                                                                                H
                                                                            </option>
                                                                            <option value="I">
                                                                                I
                                                                            </option>
                                                                            <option value="J">
                                                                                J
                                                                            </option>
                                                                            <option value="K">
                                                                                K
                                                                            </option>
                                                                            <option value="L">
                                                                                L
                                                                            </option>
                                                                            <option value="M">
                                                                                M
                                                                            </option>
                                                                            <option value="N">
                                                                                N
                                                                            </option>
                                                                            <option value="O">
                                                                                O
                                                                            </option>
                                                                            <option value="P">
                                                                                P
                                                                            </option>
                                                                            <option value="Q">
                                                                                Q
                                                                            </option>
                                                                            <option value="R">
                                                                                R
                                                                            </option>
                                                                            <option value="S">
                                                                                S
                                                                            </option>
                                                                            <option value="T">
                                                                                T
                                                                            </option>
                                                                            <option value="U">
                                                                                U
                                                                            </option>
                                                                            <option value="V">
                                                                                V
                                                                            </option>
                                                                            <option value="W">
                                                                                W
                                                                            </option>
                                                                            <option value="X">
                                                                                X
                                                                            </option>
                                                                            <option value="Y">
                                                                                Y
                                                                            </option>
                                                                            <option value="Z">
                                                                                Z
                                                                            </option>
                                                                        </select>
                                                                        <small className="error-message form-text">
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <div className="col-4">
                                                            <Field name="numeroViaGeneradora">
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="numeroViaGeneradora">
                                                                            Número:*
                                                                        </label>
                                                                        <input
                                                                            {...input}
                                                                            type="text"
                                                                            name="numeroViaGeneradora"
                                                                            id="numeroViaGeneradora"
                                                                            className={
                                                                                meta.error &&
                                                                                meta.touched
                                                                                    ? "w-100 invalid"
                                                                                    : "w-100"
                                                                            }
                                                                        ></input>
                                                                        <small className="error-message form-text">
                                                                            {" "}
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <div className="col-4">
                                                            <Field name="sectorSecun">
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="sectorSecun">
                                                                            Orientación:
                                                                        </label>
                                                                        <select
                                                                            {...input}
                                                                            name="sectorSecun"
                                                                            id="sectorSecun"
                                                                            className="w-100"
                                                                        >
                                                                            <option value="">
                                                                                Seleccionar
                                                                            </option>
                                                                            <option value="Norte">
                                                                                Norte
                                                                            </option>
                                                                            <option value="Sur">
                                                                                Sur
                                                                            </option>
                                                                            <option value="Este">
                                                                                Este
                                                                            </option>
                                                                            <option value="Oeste">
                                                                                Oeste
                                                                            </option>
                                                                        </select>
                                                                        <small className="error-message form-text">
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <Field name="complemento">
                                                                {({
                                                                      input,
                                                                      meta,
                                                                  }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="complemento">
                                                                            Complemento:
                                                                        </label>
                                                                        <input
                                                                            {...input}
                                                                            type="text"
                                                                            name="complemento"
                                                                            id="complemento"
                                                                            className="w-100"
                                                                            placeholder="Casa 200, apto, Torre, bloque, etc"
                                                                        ></input>
                                                                        <small className="error-message form-text">
                                                                            {" "}
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>
                                                        <FormSpy
                                                            subscription={{
                                                                values: true,
                                                            }}
                                                        >
                                                            {(props) => (
                                                                <div className="col-lg-12">
                                                                    <Field name="direcciónGenerada">
                                                                        {({
                                                                              input,
                                                                              meta,
                                                                          }) => (
                                                                            <div
                                                                                className="form-group gov-co-form-group w-100">
                                                                                <label htmlFor="direcciónGenerada">
                                                                                    Dirección
                                                                                    generada:
                                                                                </label>
                                                                                <input
                                                                                    {...input}
                                                                                    value={direcciónZonaUrbana(
                                                                                        props.values
                                                                                    )}
                                                                                    type="text"
                                                                                    name="direcciónGenerada"
                                                                                    id="direcciónGenerada"
                                                                                    className="w-100"
                                                                                ></input>
                                                                                <small
                                                                                    className="error-message form-text">
                                                                                    {" "}
                                                                                    {meta.error &&
                                                                                        meta.touched && (
                                                                                            <span>
                                                                                                {
                                                                                                    meta.error
                                                                                                }
                                                                                            </span>
                                                                                        )}
                                                                                </small>
                                                                            </div>
                                                                        )}
                                                                    </Field>
                                                                </div>
                                                            )}
                                                        </FormSpy>
                                                    </>
                                                ) : (
                                                    <div className="col-lg-12">
                                                        <div className="form-group gov-co-form-group w-100">
                                                            <label htmlFor="direcciónGenerada">
                                                                Dirección
                                                                generada:
                                                            </label>
                                                            <div
                                                                className="d-flex flex-row"
                                                                style={{
                                                                    gap: "10px",
                                                                }}
                                                            >
                                                                <input
                                                                    value={
                                                                        dataForm
                                                                            ?.residencia
                                                                            ?.direccion
                                                                    }
                                                                    type="text"
                                                                    name="direcciónGenerada"
                                                                    id="direcciónGenerada"
                                                                    className="col-9"
                                                                ></input>
                                                                <button
                                                                    name="edit"
                                                                    type="submit"
                                                                    className="btn btn-round btn-high boton-inicio ms-1"
                                                                    onClick={() =>
                                                                        showAddressEvent()
                                                                    }
                                                                >
                                                                    Editar
                                                                    dirección
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </>
                                        )
                                    )}
                                </div>
                            </div>

                            <FormSpy
                                subscription={{values: true}}
                                onChange={(props) => {
                                    setIdLocalidad(props.values.localidad);
                                    if (
                                        props.values.departamentoNacimiento !==
                                        idDepartamento
                                    ) {
                                        setIdDepartamento(
                                            props.values.departamentoNacimiento
                                        );
                                        props.values.municipioNacimiento =
                                            undefined;
                                        setMunicipios(
                                            props.values.municipioNacimiento
                                        );
                                    }
                                    if (
                                        props.values.departamentoResidencia !==
                                        idDepartamentoResi
                                    ) {
                                        setIdDepartamentoResi(
                                            props.values.departamentoResidencia
                                        );
                                        props.values.municipioResidencia =
                                            undefined;
                                        setMunicipiosResi(
                                            props.values.municipioResidencia
                                        );
                                    }
                                    setIdGrupoEt(props.values.grupoÉtnico);
                                    setIdArea(props.values.zona);
                                    setIdComunidad(
                                        props.values.comunidadIndígena
                                    );
                                }}
                            />
                        </Wizard.Page>

                        {/* Page 2 */}

                        <Wizard.Page validate={validatePage2}>
                            <div className="text-center col-lg-12 mt-3 mb-3">
                                <b>Nivel socioeconómico</b>
                            </div>
                            <div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <label htmlFor="conQuienReside">
                                            ¿Con quién reside actualmente?:*
                                        </label>
                                        <Field
                                            name="conQuienReside"
                                            component={selectResiden}
                                            className="react-select"
                                        />
                                    </div>
                                    {idEstado?.id === 23 && (
                                        <div className="col-lg-6">
                                            <Field
                                                defaultValue={
                                                    dataForm
                                                        ?.nivel_socioeconomico
                                                        ?.indique_con_quien_reside
                                                }
                                                name="otroConQuienReside"
                                            >
                                                {({ input, meta }) => (
                                                    <div className="form-group gov-co-form-group w-100">
                                                        <label htmlFor="otroConQuienReside">
                                                            ¿Otro? Indique con
                                                            quién reside:*
                                                        </label>
                                                        <input
                                                            {...input}
                                                            type="text"
                                                            name="otroConQuienReside"
                                                            id="otroConQuienReside"
                                                            className={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "w-100 invalid"
                                                                    : "w-100"
                                                            }
                                                        ></input>
                                                        <small className="error-message form-text">
                                                            {" "}
                                                            {meta.error &&
                                                                meta.touched && (
                                                                    <span>
                                                                        {
                                                                            meta.error
                                                                        }
                                                                    </span>
                                                                )}
                                                        </small>
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                    )}
                                    <div className="col-lg-6">
                                        <label htmlFor="estrato">
                                            Estrato:*
                                        </label>
                                        <Field
                                            name="estrato"
                                            id="estrato"
                                            component={selectEstrato}
                                        />
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="dependeEconómicamente">
                                            ¿Depende económicamente de
                                            alguien?:*
                                        </label>
                                        <Field
                                            name="dependeEconómicamente"
                                            id={
                                                dataForm?.nivel_socioeconomico
                                                    ?.dependende_economicamente
                                            }
                                            component={selectSiNo}
                                        />
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="tienePuntajeSisben">
                                            ¿Tiene puntaje Sisbén?:*
                                        </label>
                                        <Field
                                            name="tienePuntajeSisben"
                                            id={
                                                dataForm?.nivel_socioeconomico
                                                    ?.puntaje_sisben
                                            }
                                            component={selectSiNo}
                                        />
                                    </div>
                                    {idSisben?.id === 30 && (
                                        <>
                                            <div className="col-lg-6">
                                                <label htmlFor="cualPuntajeSisben">
                                                    Puntaje Sisbén:*
                                                </label>
                                                <Field
                                                    component={
                                                        selectPuntajeSisben
                                                    }
                                                    name="cualPuntajeSisben"
                                                    id="cualPuntajeSisben"
                                                />
                                            </div>
                                        </>
                                    )}

                                    <div className="col-lg-6">
                                        <label htmlFor="listadoCensal">
                                            ¿Hace parte de un listado censal?:*
                                        </label>
                                        <Field
                                            name="listadoCensal"
                                            id={
                                                dataForm?.nivel_socioeconomico
                                                    ?.hace_parte_listado_censal
                                            }
                                            component={selectSiNo}
                                        />
                                    </div>
                                    {idCencial?.id === 30 && (
                                        <>
                                            <div
                                                className="col-lg-12"
                                                style={{ marginTop: "20px" }}
                                            >
                                                <label htmlFor="indiqueListadoCensal">
                                                    Sí hace parte de un listado
                                                    censal, indique cuál:*
                                                </label>
                                                <Field
                                                    id="indiqueListadoCensal"
                                                    name="indiqueListadoCensal"
                                                    component={selectCensal}
                                                />
                                            </div>
                                            {idOtro?.id === 116 && (
                                                <>
                                                    <div className="col-lg-12">
                                                        <Field
                                                            defaultValue={
                                                                dataForm
                                                                    ?.nivel_socioeconomico
                                                                    ?.otro_listado_censal
                                                            }
                                                            name="cualListadoCensal"
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <div className="form-group gov-co-form-group w-100">
                                                                    <label htmlFor="cualListadoCensal">
                                                                        ¿Otro?
                                                                        Indique
                                                                        cuál
                                                                        listado
                                                                        censal:*
                                                                    </label>
                                                                    <input
                                                                        {...input}
                                                                        type="text"
                                                                        name="cualListadoCensal"
                                                                        id="cualListadoCensal"
                                                                        className={
                                                                            meta.error &&
                                                                            meta.touched
                                                                                ? "w-100 invalid"
                                                                                : "w-100"
                                                                        }
                                                                    ></input>
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </div>
                                                            )}
                                                        </Field>
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}

                                    <div
                                        className="col-lg-12"
                                        style={{ marginTop: "20px" }}
                                    >
                                        <label htmlFor="agremiación">
                                            ¿Hace parte de una agremiación o
                                            asociación que pague su salud
                                            teniendo ingresos inferiores a 1
                                            salario mínimo mensual legal vigente
                                            (SMMLV)?:*
                                        </label>
                                        <Field
                                            name="agremiación"
                                            id={
                                                dataForm?.sistema_salud
                                                    ?.hace_parte_agremiacion_asociacion_salud
                                            }
                                            component={selectSiNo}
                                        />
                                    </div>
                                    {idAgremiacion?.id === 30 && (
                                        <div
                                            className="col-lg-12"
                                            style={{ marginTop: "20px" }}
                                        >
                                            <label htmlFor="tipoAgremiación">
                                                Tipo de agremiación:*
                                            </label>
                                            <Field
                                                id={
                                                    dataForm?.sistema_salud
                                                        ?.tipo_agremiacion_asociacion_salud
                                                }
                                                name="tipoAgremiación"
                                                component={
                                                    selectTipoAgremiacion
                                                }
                                            />
                                        </div>
                                    )}
                                    {tipoAgremiacion?.id === 108 && (
                                        <>
                                            <div className="col-lg-12">
                                                <Field
                                                    defaultValue={
                                                        dataForm?.sistema_salud
                                                            ?.nombre_agremiacion_asociacion_salud
                                                    }
                                                    name="cualAgremiación"
                                                >
                                                    {({ input, meta }) => (
                                                        <div className="form-group gov-co-form-group w-100">
                                                            <label htmlFor="cualAgremiación">
                                                                ¿Cual? Cuál
                                                                agremiación:*
                                                            </label>
                                                            <input
                                                                {...input}
                                                                type="text"
                                                                name="cualAgremiación"
                                                                id="cualAgremiación"
                                                                className={
                                                                    meta.error &&
                                                                    meta.touched
                                                                        ? "w-100 invalid"
                                                                        : "w-100"
                                                                }
                                                            ></input>
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </div>
                                                    )}
                                                </Field>
                                            </div>
                                        </>
                                    )}
                                    <div className="text-center col-lg-12 mt-3 mb-3">
                                        <b>
                                            Afiliación al Sistema de Seguridad
                                            Social en Salud
                                        </b>
                                    </div>
                                    <div className="col-lg-12">
                                        <label htmlFor="afiliaciónSalud">
                                            Usted está afiliado al sistema de
                                            salud como:*
                                        </label>
                                        <Field
                                            name="afiliaciónSalud"
                                            id="afiliaciónSalud"
                                            component={selectAfiliado}
                                        />
                                        {idContri?.id === 35 && (
                                            <>
                                                <p>
                                                    Una de las condiciones de
                                                    acceso a los BEPS señala por
                                                    el Decreto 2012 de 2017
                                                    señala " Percibir ingresos
                                                    inferiores a un (1) Salario
                                                    Mínimo Mensual Legal
                                                    Vigente.
                                                </p>
                                            </>
                                        )}
                                        {idContri?.id === 109 && (
                                            <>
                                                <p>
                                                    Una de las condiciones de
                                                    acceso a los BEPS señala por
                                                    el Decreto 2012 de 2017
                                                    señala " Percibir ingresos
                                                    inferiores a un (1) Salario
                                                    Mínimo Mensual Legal
                                                    Vigente.
                                                    <br /> Si seleccionó
                                                    contribuyente es porque
                                                    percibe mas de un (1)
                                                    Salario Mínimo Mensual Legal
                                                    Vigente y no puede continuar
                                                    con el proceso
                                                </p>
                                            </>
                                        )}
                                    </div>

                                    <div className="text-center col-lg-12 mt-3 mb-3">
                                        <b>Discapacidad</b>
                                    </div>

                                    <div className="col-lg-12">
                                        <label htmlFor="tieneDiscapacidad">
                                            ¿Tiene alguna discapacidad?:*
                                        </label>
                                        <Field
                                            name="tieneDiscapacidad"
                                            id={
                                                dataForm?.sistema_salud
                                                    ?.tiene_discapacidad
                                            }
                                            component={selectSiNo}
                                        />
                                    </div>
                                    {idDiscapacidad?.id === 30 && (
                                        <>
                                            <div className="col-lg-12">
                                                <label htmlFor="cualDiscapacidad">
                                                    ¿Otra? Cuál otra
                                                    discapacidad:*
                                                </label>
                                                <Field
                                                    name="cualDiscapacidad"
                                                    id="cualDiscapacidad"
                                                    component={
                                                        selectDiscapacidad
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}
                                    {selectedDiscapacidad?.id === 461 && (
                                        <>
                                            <div className="col-lg-12">
                                                <Field
                                                    defaultValue={
                                                        dataForm?.sistema_salud
                                                            ?.indique_discapacidad_otra
                                                    }
                                                    name="cualOtraDiscapacidad"
                                                >
                                                    {({ input, meta }) => (
                                                        <div className="form-group gov-co-form-group w-100">
                                                            <label htmlFor="cualOtraDiscapacidad">
                                                                ¿Cuál otra
                                                                discapacidad?:*
                                                            </label>
                                                            <input
                                                                {...input}
                                                                type="text"
                                                                name="cualOtraDiscapacidad"
                                                                id="cualOtraDiscapacidad"
                                                                className={
                                                                    meta.error &&
                                                                    meta.touched
                                                                        ? "w-100 invalid"
                                                                        : "w-100"
                                                                }
                                                            ></input>
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </div>
                                                    )}
                                                </Field>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>

                            <FormSpy
                                subscription={{ values: true }}
                                onChange={(props) => {
                                    setIdEstado(props.values.conQuienReside);
                                    setIdSisben(
                                        props.values.tienePuntajeSisben
                                    );
                                    setIdCencial(props.values.listadoCensal);
                                    setIdAgremiacion(props.values.agremiación);
                                    setIdContri(props.values.afiliaciónSalud);
                                    setIdDiscapacidad(
                                        props.values.tieneDiscapacidad
                                    );
                                    setSelectedDiscapacidad(
                                        props.values.cualDiscapacidad
                                    );
                                    setIdOtro(
                                        props.values.indiqueListadoCensal
                                    );
                                    setTipoAgremiacion(
                                        props.values.tipoAgremiación
                                    );
                                }}
                            />
                        </Wizard.Page>

                        {/* Page 3 */}

                        <Wizard.Page validate={validatePage3}>
                            <div className="text-center col-lg-12 mt-3 mb-3">
                                <b>Formación</b>
                            </div>
                            <div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <label htmlFor="formación">
                                            Nivel educativo alcanzado:*
                                        </label>
                                        <Field
                                            component={selectNivelEdu}
                                            name="formación"
                                        />
                                    </div>

                                    <div className="col-lg-12  mt-3 mb-3">
                                        <label htmlFor="formaciónAreaArtística">
                                            Formación en áreas artísticas o
                                            culturales
                                        </label>
                                        <Field
                                            id={
                                                dataForm?.formaciones
                                                    ?.formacion_areas_artisticas
                                            }
                                            component={selectAreasArt}
                                            name="formaciónAreaArtística"
                                        />
                                    </div>
                                    {formacionArt?.id === 96 && (
                                        <div className="col-lg-12">
                                            <Field
                                                defaultValue={
                                                    dataForm?.formaciones
                                                        ?.otra_area_formacion
                                                }
                                                name="otraFormaciónArtística"
                                            >
                                                {({ input, meta }) => (
                                                    <div className="form-group gov-co-form-group w-100">
                                                        <label htmlFor="otraFormaciónArtística ">
                                                            Si la formación es
                                                            en otra disciplina
                                                            artística o
                                                            cultural, indique
                                                            cuál:*
                                                        </label>
                                                        <input
                                                            {...input}
                                                            type="text"
                                                            name="otraFormaciónArtística"
                                                            id="otraFormaciónArtística"
                                                            className={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "w-100 invalid"
                                                                    : "w-100"
                                                            }
                                                        ></input>
                                                        <small className="error-message form-text">
                                                            {" "}
                                                            {meta.error &&
                                                                meta.touched && (
                                                                    <span>
                                                                        {
                                                                            meta.error
                                                                        }
                                                                    </span>
                                                                )}
                                                        </small>
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                    )}

                                    <div className="text-center col-lg-12 mt-3 mb-3">
                                        <b>
                                            Especifique su formación como
                                            creador o gestor cultural
                                        </b>
                                    </div>
                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[0]
                                                    ?.id
                                            }
                                            name="idFormacion1"
                                        >
                                            {({ input, meta }) => (
                                                <div
                                                    style={{ display: "none" }}
                                                    className="form-group gov-co-form-group w-100"
                                                >
                                                    <input
                                                        style={{
                                                            display: "none",
                                                        }}
                                                        {...input}
                                                        type="text"
                                                        name="idFormacion1"
                                                        id="idFormacion1"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[0]
                                                    ?.area_formacion
                                            }
                                            name="areaFormación1"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="areaFormación1">
                                                        1:Área de formación:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="areaFormación1"
                                                        id="areaFormación1"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[0]
                                                    ?.tiempo_cursado
                                            }
                                            name="tiempoCursado1"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="tiempoCursado1">
                                                        1:Tiempo cursado (Años):
                                                    </label>
                                                    <input
                                                        {...input}
                                                        min="1"
                                                        max="100"
                                                        type="number"
                                                        name="tiempoCursado1"
                                                        id="tiempoCursado1"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[0]
                                                    ?.titulo_obtenido
                                            }
                                            name="tituloObtenido1"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="tituloObtenido1">
                                                        1:Título obtenido:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="tituloObtenido1"
                                                        id="tituloObtenido1"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[1]
                                                    ?.id
                                            }
                                            name="idFormacion2"
                                        >
                                            {({ input, meta }) => (
                                                <div
                                                    style={{ display: "none" }}
                                                    className="form-group gov-co-form-group w-100"
                                                >
                                                    <input
                                                        style={{
                                                            display: "none",
                                                        }}
                                                        {...input}
                                                        type="text"
                                                        name="idFormacion2"
                                                        id="idFormacion2"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[1]
                                                    ?.area_formacion
                                            }
                                            name="areaFormación2"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="areaFormación2">
                                                        2:Área de formación:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="areaFormación2"
                                                        id="areaFormación2"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[1]
                                                    ?.tiempo_cursado
                                            }
                                            name="tiempoCursado2"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="tiempoCursado2">
                                                        2:Tiempo cursado (Años):
                                                    </label>
                                                    <input
                                                        {...input}
                                                        min="1"
                                                        max="100"
                                                        type="number"
                                                        name="tiempoCursado2"
                                                        id="tiempoCursado2"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[1]
                                                    ?.titulo_obtenido
                                            }
                                            name="tituloObtenido2"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="tituloObtenido2">
                                                        2:Título obtenido:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="tituloObtenido2"
                                                        id="tituloObtenido2"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[2]
                                                    ?.id
                                            }
                                            name="idFormacion3"
                                        >
                                            {({ input, meta }) => (
                                                <div
                                                    style={{ display: "none" }}
                                                    className="form-group gov-co-form-group w-100"
                                                >
                                                    <input
                                                        style={{
                                                            display: "none",
                                                        }}
                                                        {...input}
                                                        type="text"
                                                        name="idFormacion3"
                                                        id="idFormacion3"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[2]
                                                    ?.area_formacion
                                            }
                                            name="areaFormación3"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="areaFormación3">
                                                        3:Área de formación:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="areaFormación3"
                                                        id="areaFormación3"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[2]
                                                    ?.tiempo_cursado
                                            }
                                            name="tiempoCursado3"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="tiempoCursado3">
                                                        3:Tiempo cursado (Años):
                                                    </label>
                                                    <input
                                                        {...input}
                                                        min="1"
                                                        max="100"
                                                        type="number"
                                                        name="tiempoCursado3"
                                                        id="tiempoCursado3"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[2]
                                                    ?.titulo_obtenido
                                            }
                                            name="tituloObtenido3"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="tituloObtenido3">
                                                        3:Título obtenido:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="tituloObtenido3"
                                                        id="tituloObtenido3"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[3]
                                                    ?.id
                                            }
                                            name="idFormacion4"
                                        >
                                            {({ input, meta }) => (
                                                <div
                                                    style={{ display: "none" }}
                                                    className="form-group gov-co-form-group w-100"
                                                >
                                                    <input
                                                        style={{
                                                            display: "none",
                                                        }}
                                                        {...input}
                                                        type="text"
                                                        name="idFormacion4"
                                                        id="idFormacion4"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[3]
                                                    ?.area_formacion
                                            }
                                            name="areaFormación4"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="areaFormación4">
                                                        4:Área de formación:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="areaFormación4"
                                                        id="areaFormación4"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[3]
                                                    ?.tiempo_cursado
                                            }
                                            name="tiempoCursado4"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="tiempoCursado4">
                                                        4:Tiempo cursado (Años):
                                                    </label>
                                                    <input
                                                        {...input}
                                                        min="1"
                                                        max="100"
                                                        type="number"
                                                        name="tiempoCursado4"
                                                        id="tiempoCursado4"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-4">
                                        <Field
                                            defaultValue={
                                                dataForm
                                                    ?.formacion_artistica?.[3]
                                                    ?.titulo_obtenido
                                            }
                                            name="tituloObtenido4"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="tituloObtenido4">
                                                        4:Título obtenido:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="tituloObtenido4"
                                                        id="tituloObtenido4"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="text-center col-lg-12 mt-3 mb-3">
                                        <b>Experiencia artística o cultural</b>
                                    </div>

                                    <div className="col-lg-12">
                                        <label htmlFor="actividadArtística">
                                            Principal actividad de creación o
                                            gestión en la que se ha
                                            desempeñado:*
                                        </label>
                                        <Field
                                            id={
                                                dataForm?.experiencia_artistica
                                                    ?.principal_actividad_creacion
                                            }
                                            component={selectAreasArt}
                                            name="actividadArtística"
                                        />
                                    </div>

                                    {expArt?.id === 96 && (
                                        <div className="col-lg-12">
                                            <Field
                                                defaultValue={
                                                    dataForm
                                                        ?.experiencia_artistica
                                                        ?.principal_otra_disciplina_produccion_artistica
                                                }
                                                name="otraActividad"
                                            >
                                                {({ input, meta }) => (
                                                    <div className="form-group gov-co-form-group w-100">
                                                        <label htmlFor="otraActividad">
                                                            ¿Otra? Cuál
                                                            actividad:*
                                                        </label>
                                                        <input
                                                            {...input}
                                                            type="text"
                                                            name="otraActividad"
                                                            id="otraActividad"
                                                            className={
                                                                meta.error &&
                                                                meta.touched
                                                                    ? "w-100 invalid"
                                                                    : "w-100"
                                                            }
                                                        ></input>
                                                        <small className="error-message form-text">
                                                            {" "}
                                                            {meta.error &&
                                                                meta.touched && (
                                                                    <span>
                                                                        {
                                                                            meta.error
                                                                        }
                                                                    </span>
                                                                )}
                                                        </small>
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                    )}

                                    <FormSpy subscription={{ values: true }}>
                                        {(props) => (
                                            <>
                                                {props.values
                                                    .actividadArtística !==
                                                "Ninguna" ? (
                                                    <>
                                                        <div className="col-lg-6">
                                                            <Field
                                                                defaultValue={
                                                                    dataForm?.tiempoActividadAnios
                                                                }
                                                                name="tiempoActividadAños"
                                                            >
                                                                {({
                                                                    input,
                                                                    meta,
                                                                }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="tiempoActividadAños">
                                                                            Especifique
                                                                            el
                                                                            tiempo
                                                                            dedicado
                                                                            a la
                                                                            actividad
                                                                            señalada
                                                                            (años):*
                                                                        </label>
                                                                        <input
                                                                            {...input}
                                                                            min="0"
                                                                            max="100"
                                                                            type="number"
                                                                            name="tiempoActividadAños"
                                                                            id="tiempoActividadAños"
                                                                            className={
                                                                                meta.error &&
                                                                                meta.touched
                                                                                    ? "w-100 invalid"
                                                                                    : "w-100"
                                                                            }
                                                                        ></input>
                                                                        <small className="error-message form-text">
                                                                            {" "}
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <Field
                                                                defaultValue={
                                                                    dataForm?.tiempoActividadMeses
                                                                }
                                                                name="tiempoActividadMeses"
                                                            >
                                                                {({
                                                                    input,
                                                                    meta,
                                                                }) => (
                                                                    <div className="form-group gov-co-form-group w-100">
                                                                        <label htmlFor="tiempoActividadMeses">
                                                                            Especifique
                                                                            el
                                                                            tiempo
                                                                            dedicado
                                                                            a la
                                                                            actividad
                                                                            señalada
                                                                            (Meses):*
                                                                        </label>
                                                                        <input
                                                                            {...input}
                                                                            min="0"
                                                                            max="100"
                                                                            type="number"
                                                                            name="tiempoActividadMeses"
                                                                            id="tiempoActividadMeses"
                                                                            className={
                                                                                meta.error &&
                                                                                meta.touched
                                                                                    ? "w-100 invalid"
                                                                                    : "w-100"
                                                                            }
                                                                        ></input>
                                                                        <small className="error-message form-text">
                                                                            {" "}
                                                                            {meta.error &&
                                                                                meta.touched && (
                                                                                    <span>
                                                                                        {
                                                                                            meta.error
                                                                                        }
                                                                                    </span>
                                                                                )}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>

                                                        <div className="col-lg-6">
                                                            <Field name="desempeñaActividad">
                                                                {({
                                                                    input,
                                                                    meta,
                                                                }) => (
                                                                    <div>
                                                                        <label htmlFor="desempeñaActividad">
                                                                            ¿Actualmente
                                                                            se
                                                                            desempeña
                                                                            en
                                                                            esta
                                                                            actividad?
                                                                        </label>
                                                                        <Field
                                                                            id={
                                                                                dataForm
                                                                                    ?.experiencia_artistica
                                                                                    ?.desempena_actividad_actualmente
                                                                            }
                                                                            name="desempeñaActividad"
                                                                            component={
                                                                                selectSiNo
                                                                            }
                                                                        />
                                                                    </div>
                                                                )}
                                                            </Field>
                                                        </div>

                                                        {siNo?.detalle ===
                                                            "No" && (
                                                            <div className="col-lg-12">
                                                                <Field
                                                                    defaultValue={
                                                                        dataForm
                                                                            ?.experiencia_artistica
                                                                            ?.otra_disciplina_produccion_artistica
                                                                    }
                                                                    name="cualDesempeña"
                                                                >
                                                                    {({
                                                                        input,
                                                                        meta,
                                                                    }) => (
                                                                        <div className="form-group gov-co-form-group w-100">
                                                                            <label htmlFor="cualDesempeña">
                                                                                Si
                                                                                no
                                                                                desempeña
                                                                                actualmente
                                                                                esta
                                                                                actividad,
                                                                                indique
                                                                                en
                                                                                cual:*
                                                                            </label>
                                                                            <input
                                                                                {...input}
                                                                                type="text"
                                                                                name="cualDesempeña"
                                                                                id="cualDesempeña"
                                                                                className={
                                                                                    meta.error &&
                                                                                    meta.touched
                                                                                        ? "w-100 invalid"
                                                                                        : "w-100"
                                                                                }
                                                                            ></input>
                                                                            <small className="error-message form-text">
                                                                                {" "}
                                                                                {meta.error &&
                                                                                    meta.touched && (
                                                                                        <span>
                                                                                            {
                                                                                                meta.error
                                                                                            }
                                                                                        </span>
                                                                                    )}
                                                                            </small>
                                                                        </div>
                                                                    )}
                                                                </Field>
                                                            </div>
                                                        )}
                                                    </>
                                                ) : null}
                                            </>
                                        )}
                                    </FormSpy>
                                    <FormSpy
                                        subscription={{ values: true }}
                                        onChange={(props) => {
                                            setSiNo(
                                                props.values.desempeñaActividad
                                            );
                                            setformacionArt(
                                                props.values
                                                    .formaciónAreaArtística
                                            );
                                            setExpArt(
                                                props.values.actividadArtística
                                            );
                                        }}
                                    />
                                </div>
                            </div>
                        </Wizard.Page>

                        {/* Page 4 */}

                        <Wizard.Page validate={validatePage4}>
                            <div className="text-center col-lg-12 mt-3 mb-3">
                                <b>Situación laboral</b>
                            </div>
                            <div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <label htmlFor="tieneContratoLaboral">
                                            ¿Actualmente, usted tiene algún tipo
                                            de contrato laboral?:*
                                        </label>
                                        <Field
                                            component={selectSiNo}
                                            name="tieneContratoLaboral"
                                            id={
                                                dataForm?.situacion_laboral
                                                    ?.tiene_contrato_laboral
                                            }
                                        />
                                    </div>

                                    {siNo?.detalle === "Si" && (
                                        <div className="col-lg-12">
                                            <Field name="tipoContrato">
                                                {({ input, meta }) => (
                                                    <div>
                                                        <label htmlFor="tipoContrato">
                                                            ¿Tipo de contrato
                                                            laboral?:*
                                                        </label>
                                                        <Field
                                                            {...input}
                                                            id={
                                                                dataForm
                                                                    ?.situacion_laboral
                                                                    ?.tipo_contrato
                                                            }
                                                            component={
                                                                selectTipoContrato
                                                            }
                                                        ></Field>
                                                        <small className="error-message form-text">
                                                            {" "}
                                                            {meta.error &&
                                                                meta.touched && (
                                                                    <span>
                                                                        {
                                                                            meta.error
                                                                        }
                                                                    </span>
                                                                )}
                                                        </small>
                                                    </div>
                                                )}
                                            </Field>
                                        </div>
                                    )}

                                    <div className="col-lg-12">
                                        <label htmlFor="ingresosActuales">
                                            Sus ingresos actuales corresponden
                                            a:*
                                        </label>
                                        <Field
                                            id={
                                                dataForm?.situacion_laboral
                                                    ?.ingresos_actuales
                                            }
                                            name="ingresosActuales"
                                            component={selectIngresos}
                                        />
                                        {salar?.id === 77 && (
                                            <>
                                                <p>
                                                    Una de las condiciones de
                                                    acceso a los BEPS según el
                                                    Decreto 2012 de 2017 señala
                                                    que debe "Percibir ingresos
                                                    inferiores a un (1) Salario
                                                    Mínimo Mensual Legal
                                                    Vigente."
                                                </p>
                                            </>
                                        )}

                                        <FormSpy
                                            subscription={{ values: true }}
                                            onChange={(props) => {
                                                setSiNo(
                                                    props.values
                                                        .tieneContratoLaboral
                                                );
                                                setSala(
                                                    props.values
                                                        .ingresosActuales
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Wizard.Page>

                        {/* Page 5 */}

                        <Wizard.Page validate={validatePage5}>
                            <div className="text-center col-lg-12 mt-3 mb-3">
                                <b>Datos de contacto</b>
                            </div>
                            <div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.contacto
                                                    ?.correo_electronico
                                            }
                                            name="correoElectrónico"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="correoElectrónico">
                                                        Correo electrónico:*
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="email"
                                                        name="correoElectrónico"
                                                        id="correoElectrónico"
                                                        className={
                                                            meta.error &&
                                                            meta.touched
                                                                ? "w-100 invalid"
                                                                : "w-100"
                                                        }
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.contacto?.celular
                                            }
                                            name="numeroCelular"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="numeroCelular">
                                                        Número de celular:*
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="tel"
                                                        name="numeroCelular"
                                                        id="numeroCelular"
                                                        pattern="[0-9]{3}[0-9]{3}[0-9]{2}[0-9]{2}"
                                                        className={
                                                            meta.error &&
                                                            meta.touched
                                                                ? "w-100 invalid"
                                                                : "w-100"
                                                        }
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.contacto?.numero_fijo
                                            }
                                            name="teléfono"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="teléfono">
                                                        Número de teléfono:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="tel"
                                                        name="teléfono"
                                                        id="teléfono"
                                                        //  pattern="[0-9]{3}[0-9]{2}[0-9]{2}"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-6">
                                        <Field
                                            defaultValue={
                                                dataForm?.contacto
                                                    ?.telefono_allegado
                                            }
                                            name="teléfonoFamiliar"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="teléfonoFamiliar">
                                                        Número de teléfono de un
                                                        familiar o allegado:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="tel"
                                                        name="teléfonoFamiliar"
                                                        id="teléfonoFamiliar"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>

                                    <div className="col-lg-12">
                                        <Field
                                            defaultValue={
                                                dataForm?.contacto?.pagina_web
                                            }
                                            name="paginaWeb"
                                        >
                                            {({ input, meta }) => (
                                                <div className="form-group gov-co-form-group w-100">
                                                    <label htmlFor="teléfono">
                                                        Página web o Redes
                                                        sociales:
                                                    </label>
                                                    <input
                                                        {...input}
                                                        type="text"
                                                        name="paginaWeb"
                                                        id="paginaWeb"
                                                        className="w-100"
                                                    ></input>
                                                    <small className="error-message form-text">
                                                        {" "}
                                                        {meta.error &&
                                                            meta.touched && (
                                                                <span>
                                                                    {meta.error}
                                                                </span>
                                                            )}
                                                    </small>
                                                </div>
                                            )}
                                        </Field>
                                    </div>
                                </div>
                            </div>
                        </Wizard.Page>

                        {/* Page 6 */}

                        <Wizard.Page
                            validate={validatePage6}
                            loadConfig={chargeData}
                        >
                            <h2 className="col-lg-12">Adjuntar Documentos</h2>
                            <FormSpy subscription={{ values: true }}>
                                {(props) => (
                                    <div>
                                        <div className="row">
                                            <div className="col-lg-12 mb-4">
                                                <h6 className="col-lg-12">
                                                    Documentos generales *
                                                </h6>
                                                <Field
                                                    name="documentoDeIdentificación"
                                                    defaultValue={
                                                        dataForm?.documentoDeIdentificación
                                                    }
                                                >
                                                    {({ input, meta }) => (
                                                        <>
                                                            <p
                                                                style={{
                                                                    marginBottom:
                                                                        "-12px",
                                                                }}
                                                            >
                                                                Cédula de
                                                                ciudadanía
                                                                (fotocopia por
                                                                las dos caras):*
                                                            </p>
                                                            {props.values
                                                                .documentoDeIdentificación ? (
                                                                <div>
                                                                    <div className="files-upload">
                                                                        <p className="text-truncate">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .documentoDeIdentificación[0]
                                                                                    .name
                                                                            }
                                                                        </p>
                                                                        <div className="content-buttons">
                                                                            {props
                                                                                .values
                                                                                .documentoDeIdentificación[0]
                                                                                .name !==
                                                                            "Sin Archivo" ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary"
                                                                                    onClick={() =>
                                                                                        showModal(
                                                                                            props
                                                                                                .values
                                                                                                ?.documentoDeIdentificación[0]
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Ver
                                                                                </button>
                                                                            ) : (
                                                                                ""
                                                                            )}

                                                                            <button
                                                                                className="btn btn-danger ml-1"
                                                                                onClick={() => {
                                                                                    input.onChange(
                                                                                        ""
                                                                                    );
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {props
                                                                        .values
                                                                        .documentoDeIdentificación[0]
                                                                        .causal ? (
                                                                        <span className="causal-alert">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .documentoDeIdentificación[0]
                                                                                    .causal
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="form-group gov-co-form-group">
                                                                    <FileField
                                                                        name="documentoDeIdentificación"
                                                                        className="custom-file-input input-file-govco"
                                                                        style={{
                                                                            height: "112px",
                                                                        }}
                                                                        accept="application/pdf"
                                                                    ></FileField>
                                                                    <label className="custom-file-label label-file-govco">
                                                                        <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                        Arrastre
                                                                        aquí
                                                                        su(s)
                                                                        archivo(s)
                                                                        o haga
                                                                        click
                                                                        para
                                                                        añadir.
                                                                    </label>
                                                                </div>
                                                            )}
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </>
                                                    )}
                                                </Field>
                                            </div>

                                            <div className="col-lg-12 mb-4">
                                                <Field
                                                    name="declaraciónJuramentadaTerceros"
                                                    defaultValue={
                                                        dataForm?.declaraciónJuramentadaTerceros
                                                    }
                                                >
                                                    {({ input, meta }) => (
                                                        <>
                                                            <p
                                                                style={{
                                                                    marginBottom:
                                                                        "-12px",
                                                                }}
                                                            >
                                                                Declaración
                                                                juramentada
                                                                realizada por
                                                                tercero para
                                                                acreditar
                                                                trayectoria:*
                                                            </p>
                                                            {props.values
                                                                .declaraciónJuramentadaTerceros ? (
                                                                <div>
                                                                    <div className="files-upload">
                                                                        <p className="text-truncate">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .declaraciónJuramentadaTerceros[0]
                                                                                    .name
                                                                            }
                                                                        </p>
                                                                        <div className="content-buttons">
                                                                            {props
                                                                                .values
                                                                                .declaraciónJuramentadaTerceros[0]
                                                                                .name !==
                                                                            "Sin Archivo" ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary"
                                                                                    onClick={() =>
                                                                                        showModal(
                                                                                            props
                                                                                                .values
                                                                                                ?.declaraciónJuramentadaTerceros[0]
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Ver
                                                                                </button>
                                                                            ) : (
                                                                                ""
                                                                            )}

                                                                            <button
                                                                                className="btn btn-danger ml-1"
                                                                                onClick={() => {
                                                                                    input.onChange(
                                                                                        ""
                                                                                    );
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {props
                                                                        .values
                                                                        .declaraciónJuramentadaTerceros[0]
                                                                        .causal ? (
                                                                        <span className="causal-alert">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .declaraciónJuramentadaTerceros[0]
                                                                                    .causal
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="form-group gov-co-form-group">
                                                                    <FileField
                                                                        name="declaraciónJuramentadaTerceros"
                                                                        className="custom-file-input input-file-govco"
                                                                        style={{
                                                                            height: "112px",
                                                                        }}
                                                                        accept="application/pdf"
                                                                    ></FileField>
                                                                    <label className="custom-file-label label-file-govco">
                                                                        <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                        Arrastre
                                                                        aquí
                                                                        su(s)
                                                                        archivo(s)
                                                                        o haga
                                                                        click
                                                                        para
                                                                        añadir.
                                                                    </label>
                                                                </div>
                                                            )}
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </>
                                                    )}
                                                </Field>
                                            </div>

                                            <div className="col-lg-12 mb-4">
                                                <Field
                                                    name="certificadoResidencia"
                                                    defaultValue={
                                                        dataForm?.certificadoResidencia
                                                    }
                                                >
                                                    {({ input, meta }) => (
                                                        <>
                                                            <p
                                                                style={{
                                                                    marginBottom:
                                                                        "-12px",
                                                                }}
                                                            >
                                                                Certificado de
                                                                residencia:*
                                                            </p>
                                                            {props.values
                                                                .certificadoResidencia ? (
                                                                <div>
                                                                    <div className="files-upload">
                                                                        <p className="text-truncate">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .certificadoResidencia[0]
                                                                                    .name
                                                                            }
                                                                        </p>
                                                                        <div className="content-buttons">
                                                                            {props
                                                                                .values
                                                                                .certificadoResidencia[0]
                                                                                .name !==
                                                                            "Sin Archivo" ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary"
                                                                                    onClick={() =>
                                                                                        showModal(
                                                                                            props
                                                                                                .values
                                                                                                ?.certificadoResidencia[0]
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Ver
                                                                                </button>
                                                                            ) : (
                                                                                ""
                                                                            )}

                                                                            <button
                                                                                className="btn btn-danger ml-1"
                                                                                onClick={() => {
                                                                                    input.onChange(
                                                                                        ""
                                                                                    );
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {props
                                                                        .values
                                                                        .certificadoResidencia[0]
                                                                        .causal ? (
                                                                        <span className="causal-alert">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .certificadoResidencia[0]
                                                                                    .causal
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="form-group gov-co-form-group">
                                                                    <FileField
                                                                        name="certificadoResidencia"
                                                                        className="custom-file-input input-file-govco"
                                                                        style={{
                                                                            height: "112px",
                                                                        }}
                                                                        accept="application/pdf"
                                                                    ></FileField>
                                                                    <label className="custom-file-label label-file-govco">
                                                                        <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                        Arrastre
                                                                        aquí
                                                                        su(s)
                                                                        archivo(s)
                                                                        o haga
                                                                        click
                                                                        para
                                                                        añadir.
                                                                    </label>
                                                                </div>
                                                            )}
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </>
                                                    )}
                                                </Field>
                                            </div>

                                            <div className="col-lg-12 mb-4">
                                                <Field
                                                    name="certificadoAfiliaciónEps"
                                                    defaultValue={
                                                        dataForm?.certificadoAfiliaciónEps
                                                    }
                                                >
                                                    {({ input, meta }) => (
                                                        <>
                                                            <p
                                                                style={{
                                                                    marginBottom:
                                                                        "-12px",
                                                                }}
                                                            >
                                                                Certificado de
                                                                afiliación
                                                                activa a la
                                                                EPS:*
                                                            </p>
                                                            {props.values
                                                                .certificadoAfiliaciónEps ? (
                                                                <div>
                                                                    <div className="files-upload">
                                                                        <p className="text-truncate">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .certificadoAfiliaciónEps[0]
                                                                                    .name
                                                                            }
                                                                        </p>
                                                                        <div className="content-buttons">
                                                                            {props
                                                                                .values
                                                                                .certificadoAfiliaciónEps[0]
                                                                                .name !==
                                                                            "Sin Archivo" ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary"
                                                                                    onClick={() =>
                                                                                        showModal(
                                                                                            props
                                                                                                .values
                                                                                                ?.certificadoAfiliaciónEps[0]
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Ver
                                                                                </button>
                                                                            ) : (
                                                                                ""
                                                                            )}

                                                                            <button
                                                                                className="btn btn-danger ml-1"
                                                                                onClick={() => {
                                                                                    input.onChange(
                                                                                        ""
                                                                                    );
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {props
                                                                        .values
                                                                        .certificadoAfiliaciónEps[0]
                                                                        .causal ? (
                                                                        <span className="causal-alert">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .certificadoAfiliaciónEps[0]
                                                                                    .causal
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="form-group gov-co-form-group">
                                                                    <FileField
                                                                        name="certificadoAfiliaciónEps"
                                                                        className="custom-file-input input-file-govco"
                                                                        style={{
                                                                            height: "112px",
                                                                        }}
                                                                        accept="application/pdf"
                                                                    ></FileField>
                                                                    <label className="custom-file-label label-file-govco">
                                                                        <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                        Arrastre
                                                                        aquí
                                                                        su(s)
                                                                        archivo(s)
                                                                        o haga
                                                                        click
                                                                        para
                                                                        añadir.
                                                                    </label>
                                                                </div>
                                                            )}
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </>
                                                    )}
                                                </Field>
                                            </div>

                                            <h6 className="col-lg-12">
                                                Soportes de trayectoria para{" "}
                                                {stepFive?.datos_personales
                                                    ?.usted == 2
                                                    ? "gestor"
                                                    : "creador"}{" "}
                                                cultural*
                                            </h6>
                                            {stepFive?.datos_personales
                                                ?.usted == 2 ? (
                                                <>
                                                    <div className="col-lg-12 mb-4">
                                                        <Field
                                                            name="soporteTrayectoriaGestor"
                                                            defaultValue={
                                                                dataForm?.soporteTrayectoriaGestor
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "-12px",
                                                                        }}
                                                                    >
                                                                        Soportes
                                                                        de
                                                                        trayectoria
                                                                        copias
                                                                        de
                                                                        certificaciones
                                                                        o
                                                                        contratos
                                                                        suscritos
                                                                        por
                                                                        gestores
                                                                        culturales:*
                                                                    </p>
                                                                    {props
                                                                        .values
                                                                        .soporteTrayectoriaGestor ? (
                                                                        <div>
                                                                            <div className="files-upload">
                                                                                <p className="text-truncate">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .soporteTrayectoriaGestor[0]
                                                                                            .name
                                                                                    }
                                                                                </p>
                                                                                <div className="content-buttons">
                                                                                    {props
                                                                                        .values
                                                                                        .soporteTrayectoriaGestor[0]
                                                                                        .name !==
                                                                                    "Sin Archivo" ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                showModal(
                                                                                                    props
                                                                                                        .values
                                                                                                        ?.soporteTrayectoriaGestor[0]
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Ver
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <button
                                                                                        className="btn btn-danger ml-1"
                                                                                        onClick={() => {
                                                                                            input.onChange(
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {props
                                                                                .values
                                                                                .soporteTrayectoriaGestor[0]
                                                                                .causal ? (
                                                                                <span className="causal-alert">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .soporteTrayectoriaGestor[0]
                                                                                            .causal
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-group gov-co-form-group">
                                                                            <FileField
                                                                                name="soporteTrayectoriaGestor"
                                                                                className="custom-file-input input-file-govco"
                                                                                style={{
                                                                                    height: "112px",
                                                                                }}
                                                                                accept="application/pdf"
                                                                            ></FileField>
                                                                            <label className="custom-file-label label-file-govco">
                                                                                <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                                Arrastre
                                                                                aquí
                                                                                su(s)
                                                                                archivo(s)
                                                                                o
                                                                                haga
                                                                                click
                                                                                para
                                                                                añadir.
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div className="col-lg-12 mb-4">
                                                        <Field
                                                            name="otrosSoportesGestor"
                                                            defaultValue={
                                                                dataForm?.otrosSoportesGestor
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "-12px",
                                                                        }}
                                                                    >
                                                                        Otros
                                                                        soportes
                                                                        para
                                                                        acreditar
                                                                        gestión
                                                                        o
                                                                        participación
                                                                        en
                                                                        actividades
                                                                        o
                                                                        proyectos
                                                                        (gestor
                                                                        cultural):*
                                                                    </p>
                                                                    {props
                                                                        .values
                                                                        .otrosSoportesGestor ? (
                                                                        <div>
                                                                            <div className="files-upload">
                                                                                <p className="text-truncate">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .otrosSoportesGestor[0]
                                                                                            .name
                                                                                    }
                                                                                </p>
                                                                                <div className="content-buttons">
                                                                                    {props
                                                                                        .values
                                                                                        .otrosSoportesGestor[0]
                                                                                        .name !==
                                                                                    "Sin Archivo" ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                showModal(
                                                                                                    props
                                                                                                        .values
                                                                                                        ?.otrosSoportesGestor[0]
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Ver
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <button
                                                                                        className="btn btn-danger ml-1"
                                                                                        onClick={() => {
                                                                                            input.onChange(
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {props
                                                                                .values
                                                                                .otrosSoportesGestor[0]
                                                                                .causal ? (
                                                                                <span className="causal-alert">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .otrosSoportesGestor[0]
                                                                                            .causal
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-group gov-co-form-group">
                                                                            <FileField
                                                                                name="otrosSoportesGestor"
                                                                                className="custom-file-input input-file-govco"
                                                                                style={{
                                                                                    height: "112px",
                                                                                }}
                                                                                accept="application/pdf"
                                                                            ></FileField>
                                                                            <label className="custom-file-label label-file-govco">
                                                                                <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                                Arrastre
                                                                                aquí
                                                                                su(s)
                                                                                archivo(s)
                                                                                o
                                                                                haga
                                                                                click
                                                                                para
                                                                                añadir.
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="col-lg-12 mb-4">
                                                        <Field
                                                            name="certificadoRegistroObras"
                                                            defaultValue={
                                                                dataForm?.certificadoRegistroObras
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "-12px",
                                                                        }}
                                                                    >
                                                                        Certificado
                                                                        de
                                                                        registro
                                                                        de obras
                                                                        ante la
                                                                        DNDA:*
                                                                    </p>
                                                                    {props
                                                                        .values
                                                                        .certificadoRegistroObras ? (
                                                                        <div>
                                                                            <div className="files-upload">
                                                                                <p className="text-truncate">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .certificadoRegistroObras[0]
                                                                                            .name
                                                                                    }
                                                                                </p>
                                                                                <div className="content-buttons">
                                                                                    {props
                                                                                        .values
                                                                                        .certificadoRegistroObras[0]
                                                                                        .name !==
                                                                                    "Sin Archivo" ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                showModal(
                                                                                                    props
                                                                                                        .values
                                                                                                        ?.certificadoRegistroObras[0]
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Ver
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <button
                                                                                        className="btn btn-danger ml-1"
                                                                                        onClick={() => {
                                                                                            input.onChange(
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {props
                                                                                .values
                                                                                .certificadoRegistroObras[0]
                                                                                .causal ? (
                                                                                <span className="causal-alert">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .certificadoRegistroObras[0]
                                                                                            .causal
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-group gov-co-form-group">
                                                                            <FileField
                                                                                name="certificadoRegistroObras"
                                                                                className="custom-file-input input-file-govco"
                                                                                style={{
                                                                                    height: "112px",
                                                                                }}
                                                                                accept="application/pdf"
                                                                            ></FileField>
                                                                            <label className="custom-file-label label-file-govco">
                                                                                <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                                Arrastre
                                                                                aquí
                                                                                su(s)
                                                                                archivo(s)
                                                                                o
                                                                                haga
                                                                                click
                                                                                para
                                                                                añadir.
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div className="col-lg-12 mb-4">
                                                        <Field
                                                            name="certificadoSociedadColectiva"
                                                            defaultValue={
                                                                dataForm?.certificadoSociedadColectiva
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "-12px",
                                                                        }}
                                                                    >
                                                                        Certificación
                                                                        de
                                                                        afiliación
                                                                        a
                                                                        sociedad
                                                                        de
                                                                        gestión
                                                                        colectiva:*
                                                                    </p>
                                                                    {props
                                                                        .values
                                                                        .certificadoSociedadColectiva ? (
                                                                        <div>
                                                                            <div className="files-upload">
                                                                                <p className="text-truncate">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .certificadoSociedadColectiva[0]
                                                                                            .name
                                                                                    }
                                                                                </p>
                                                                                <div className="content-buttons">
                                                                                    {props
                                                                                        .values
                                                                                        .certificadoSociedadColectiva[0]
                                                                                        .name !==
                                                                                    "Sin Archivo" ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                showModal(
                                                                                                    props
                                                                                                        .values
                                                                                                        ?.certificadoSociedadColectiva[0]
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Ver
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <button
                                                                                        className="btn btn-danger ml-1"
                                                                                        onClick={() => {
                                                                                            input.onChange(
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {props
                                                                                .values
                                                                                .certificadoSociedadColectiva[0]
                                                                                .causal ? (
                                                                                <span className="causal-alert">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .certificadoSociedadColectiva[0]
                                                                                            .causal
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-group gov-co-form-group">
                                                                            <FileField
                                                                                name="certificadoSociedadColectiva"
                                                                                className="custom-file-input input-file-govco"
                                                                                style={{
                                                                                    height: "112px",
                                                                                }}
                                                                                accept="application/pdf"
                                                                            ></FileField>
                                                                            <label className="custom-file-label label-file-govco">
                                                                                <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                                Arrastre
                                                                                aquí
                                                                                su(s)
                                                                                archivo(s)
                                                                                o
                                                                                haga
                                                                                click
                                                                                para
                                                                                añadir.
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div className="col-lg-12 mb-4">
                                                        <Field
                                                            name="certificadoContratos"
                                                            defaultValue={
                                                                dataForm?.certificadoContratos
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "-12px",
                                                                        }}
                                                                    >
                                                                        Contratos
                                                                        o
                                                                        certificaciones
                                                                        de
                                                                        contratos:*
                                                                    </p>
                                                                    {props
                                                                        .values
                                                                        .certificadoContratos ? (
                                                                        <div>
                                                                            <div className="files-upload">
                                                                                <p className="text-truncate">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .certificadoContratos[0]
                                                                                            .name
                                                                                    }
                                                                                </p>
                                                                                <div className="content-buttons">
                                                                                    {props
                                                                                        .values
                                                                                        .certificadoContratos[0]
                                                                                        .name !==
                                                                                    "Sin Archivo" ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                showModal(
                                                                                                    props
                                                                                                        .values
                                                                                                        ?.certificadoContratos[0]
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Ver
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <button
                                                                                        className="btn btn-danger ml-1"
                                                                                        onClick={() => {
                                                                                            input.onChange(
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {props
                                                                                .values
                                                                                .certificadoContratos[0]
                                                                                .causal ? (
                                                                                <span className="causal-alert">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .certificadoContratos[0]
                                                                                            .causal
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-group gov-co-form-group">
                                                                            <FileField
                                                                                name="certificadoContratos"
                                                                                className="custom-file-input input-file-govco"
                                                                                style={{
                                                                                    height: "112px",
                                                                                }}
                                                                                accept="application/pdf"
                                                                            ></FileField>
                                                                            <label className="custom-file-label label-file-govco">
                                                                                <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                                Arrastre
                                                                                aquí
                                                                                su(s)
                                                                                archivo(s)
                                                                                o
                                                                                haga
                                                                                click
                                                                                para
                                                                                añadir.
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div className="col-lg-12 mb-4">
                                                        <Field
                                                            name="otrosSoportesTrayectoria"
                                                            defaultValue={
                                                                dataForm?.otrosSoportesTrayectoria
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "-12px",
                                                                        }}
                                                                    >
                                                                        Otros
                                                                        soportes
                                                                        que
                                                                        acrediten
                                                                        trayectoria
                                                                        o
                                                                        creación
                                                                        (portafolios,
                                                                        fotografías,
                                                                        fonogramas):*
                                                                    </p>
                                                                    {props
                                                                        .values
                                                                        .otrosSoportesTrayectoria ? (
                                                                        <div>
                                                                            <div className="files-upload">
                                                                                <p className="text-truncate">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .otrosSoportesTrayectoria[0]
                                                                                            .name
                                                                                    }
                                                                                </p>
                                                                                <div className="content-buttons">
                                                                                    {props
                                                                                        .values
                                                                                        .otrosSoportesTrayectoria[0]
                                                                                        .name !==
                                                                                    "Sin Archivo" ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                showModal(
                                                                                                    props
                                                                                                        .values
                                                                                                        ?.otrosSoportesTrayectoria[0]
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Ver
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <button
                                                                                        className="btn btn-danger ml-1"
                                                                                        onClick={() => {
                                                                                            input.onChange(
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {props
                                                                                .values
                                                                                .otrosSoportesTrayectoria[0]
                                                                                .causal ? (
                                                                                <span className="causal-alert">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .otrosSoportesTrayectoria[0]
                                                                                            .causal
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-group gov-co-form-group">
                                                                            <FileField
                                                                                name="otrosSoportesTrayectoria"
                                                                                className="custom-file-input input-file-govco"
                                                                                style={{
                                                                                    height: "112px",
                                                                                }}
                                                                                accept="application/pdf"
                                                                            ></FileField>
                                                                            <label className="custom-file-label label-file-govco">
                                                                                <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                                Arrastre
                                                                                aquí
                                                                                su(s)
                                                                                archivo(s)
                                                                                o
                                                                                haga
                                                                                click
                                                                                para
                                                                                añadir.
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                    <div className="col-lg-12 mb-4">
                                                        <Field
                                                            name="tarjetaProfesional"
                                                            defaultValue={
                                                                dataForm?.tarjetaProfesional
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "-12px",
                                                                        }}
                                                                    >
                                                                        Tarjeta
                                                                        profesional
                                                                        de
                                                                        artista:*
                                                                    </p>
                                                                    {props
                                                                        .values
                                                                        .tarjetaProfesional ? (
                                                                        <div>
                                                                            <div className="files-upload">
                                                                                <p className="text-truncate">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .tarjetaProfesional[0]
                                                                                            .name
                                                                                    }
                                                                                </p>
                                                                                <div className="content-buttons">
                                                                                    {props
                                                                                        .values
                                                                                        .tarjetaProfesional[0]
                                                                                        .name !==
                                                                                    "Sin Archivo" ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                showModal(
                                                                                                    props
                                                                                                        .values
                                                                                                        ?.tarjetaProfesional[0]
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Ver
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <button
                                                                                        className="btn btn-danger ml-1"
                                                                                        onClick={() => {
                                                                                            input.onChange(
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {props
                                                                                .values
                                                                                .tarjetaProfesional[0]
                                                                                .causal ? (
                                                                                <span className="causal-alert">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .tarjetaProfesional[0]
                                                                                            .causal
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-group gov-co-form-group">
                                                                            <FileField
                                                                                name="tarjetaProfesional"
                                                                                className="custom-file-input input-file-govco"
                                                                                style={{
                                                                                    height: "112px",
                                                                                }}
                                                                                accept="application/pdf"
                                                                            ></FileField>
                                                                            <label className="custom-file-label label-file-govco">
                                                                                <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                                Arrastre
                                                                                aquí
                                                                                su(s)
                                                                                archivo(s)
                                                                                o
                                                                                haga
                                                                                click
                                                                                para
                                                                                añadir.
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                </>
                                            )}

                                            <h6 className="col-lg-12">
                                                Soportes socialización para
                                                creadores y gestores culturales
                                                *
                                            </h6>

                                            <div className="col-lg-12 mb-4">
                                                <Field
                                                    name="soportesDeSocialización"
                                                    defaultValue={
                                                        dataForm?.soportesDeSocialización
                                                    }
                                                >
                                                    {({ input, meta }) => (
                                                        <>
                                                            <p
                                                                style={{
                                                                    marginBottom:
                                                                        "-12px",
                                                                }}
                                                            >
                                                                Soportes de
                                                                socialización
                                                                (material
                                                                audiovisual,
                                                                afiches,
                                                                reseñas, prensa,
                                                                programas de
                                                                mano):
                                                            </p>
                                                            {props.values
                                                                .soportesDeSocialización ? (
                                                                <div>
                                                                    <div className="files-upload">
                                                                        <p className="text-truncate">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .soportesDeSocialización[0]
                                                                                    .name
                                                                            }
                                                                        </p>
                                                                        <div className="content-buttons">
                                                                            {props
                                                                                .values
                                                                                .soportesDeSocialización[0]
                                                                                .name !==
                                                                            "Sin Archivo" ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary"
                                                                                    onClick={() =>
                                                                                        showModal(
                                                                                            props
                                                                                                .values
                                                                                                ?.soportesDeSocialización[0]
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Ver
                                                                                </button>
                                                                            ) : (
                                                                                ""
                                                                            )}

                                                                            <button
                                                                                className="btn btn-danger ml-1"
                                                                                onClick={() => {
                                                                                    input.onChange(
                                                                                        ""
                                                                                    );
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {props
                                                                        .values
                                                                        .soportesDeSocialización[0]
                                                                        .causal ? (
                                                                        <span className="causal-alert">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .soportesDeSocialización[0]
                                                                                    .causal
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="form-group gov-co-form-group">
                                                                    <FileField
                                                                        name="soportesDeSocialización"
                                                                        className="custom-file-input input-file-govco"
                                                                        style={{
                                                                            height: "112px",
                                                                        }}
                                                                        accept="application/pdf"
                                                                    ></FileField>
                                                                    <label className="custom-file-label label-file-govco">
                                                                        <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                        Arrastre
                                                                        aquí
                                                                        su(s)
                                                                        archivo(s)
                                                                        o haga
                                                                        click
                                                                        para
                                                                        añadir.
                                                                    </label>
                                                                </div>
                                                            )}
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </>
                                                    )}
                                                </Field>
                                            </div>

                                            <div className="col-lg-12 mb-4">
                                                <Field
                                                    name="premios"
                                                    defaultValue={
                                                        dataForm?.premios
                                                    }
                                                >
                                                    {({ input, meta }) => (
                                                        <>
                                                            <p
                                                                style={{
                                                                    marginBottom:
                                                                        "-12px",
                                                                }}
                                                            >
                                                                Premios,
                                                                reconocimientos,
                                                                galardones:
                                                            </p>
                                                            {props.values
                                                                .premios ? (
                                                                <div>
                                                                    <div className="files-upload">
                                                                        <p className="text-truncate">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .premios[0]
                                                                                    .name
                                                                            }
                                                                        </p>
                                                                        <div className="content-buttons">
                                                                            {props
                                                                                .values
                                                                                .premios[0]
                                                                                .name !==
                                                                            "Sin Archivo" ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary"
                                                                                    onClick={() =>
                                                                                        showModal(
                                                                                            props
                                                                                                .values
                                                                                                ?.premios[0]
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Ver
                                                                                </button>
                                                                            ) : (
                                                                                ""
                                                                            )}

                                                                            <button
                                                                                className="btn btn-danger ml-1"
                                                                                onClick={() => {
                                                                                    input.onChange(
                                                                                        ""
                                                                                    );
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {props
                                                                        .values
                                                                        .premios[0]
                                                                        .causal ? (
                                                                        <span className="causal-alert">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .premios[0]
                                                                                    .causal
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="form-group gov-co-form-group">
                                                                    <FileField
                                                                        name="premios"
                                                                        className="custom-file-input input-file-govco"
                                                                        style={{
                                                                            height: "112px",
                                                                        }}
                                                                        accept="application/pdf"
                                                                    ></FileField>
                                                                    <label className="custom-file-label label-file-govco">
                                                                        <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                        Arrastre
                                                                        aquí
                                                                        su(s)
                                                                        archivo(s)
                                                                        o haga
                                                                        click
                                                                        para
                                                                        añadir.
                                                                    </label>
                                                                </div>
                                                            )}
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </>
                                                    )}
                                                </Field>
                                            </div>

                                            <div className="col-lg-12 mb-4">
                                                <Field
                                                    name="certificaciónEventos"
                                                    defaultValue={
                                                        dataForm?.certificaciónEventos
                                                    }
                                                >
                                                    {({ input, meta }) => (
                                                        <>
                                                            <p
                                                                style={{
                                                                    marginBottom:
                                                                        "-12px",
                                                                }}
                                                            >
                                                                Certificaciones
                                                                de participación
                                                                o gestión de
                                                                eventos y
                                                                actividades
                                                                culturales:
                                                            </p>
                                                            {props.values
                                                                .certificaciónEventos ? (
                                                                <div>
                                                                    <div className="files-upload">
                                                                        <p className="text-truncate">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .certificaciónEventos[0]
                                                                                    .name
                                                                            }
                                                                        </p>
                                                                        <div className="content-buttons">
                                                                            {props
                                                                                .values
                                                                                .certificaciónEventos[0]
                                                                                .name !==
                                                                            "Sin Archivo" ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-primary"
                                                                                    onClick={() =>
                                                                                        showModal(
                                                                                            props
                                                                                                .values
                                                                                                ?.certificaciónEventos[0]
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Ver
                                                                                </button>
                                                                            ) : (
                                                                                ""
                                                                            )}

                                                                            <button
                                                                                className="btn btn-danger ml-1"
                                                                                onClick={() => {
                                                                                    input.onChange(
                                                                                        ""
                                                                                    );
                                                                                }}
                                                                            >
                                                                                X
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {props
                                                                        .values
                                                                        .certificaciónEventos[0]
                                                                        .causal ? (
                                                                        <span className="causal-alert">
                                                                            {
                                                                                props
                                                                                    .values
                                                                                    .certificaciónEventos[0]
                                                                                    .causal
                                                                            }
                                                                        </span>
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </div>
                                                            ) : (
                                                                <div className="form-group gov-co-form-group">
                                                                    <FileField
                                                                        name="certificaciónEventos"
                                                                        className="custom-file-input input-file-govco"
                                                                        style={{
                                                                            height: "112px",
                                                                        }}
                                                                        accept="application/pdf"
                                                                    ></FileField>
                                                                    <label className="custom-file-label label-file-govco">
                                                                        <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                        Arrastre
                                                                        aquí
                                                                        su(s)
                                                                        archivo(s)
                                                                        o haga
                                                                        click
                                                                        para
                                                                        añadir.
                                                                    </label>
                                                                </div>
                                                            )}
                                                            <small className="error-message form-text">
                                                                {" "}
                                                                {meta.error &&
                                                                    meta.touched && (
                                                                        <span>
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </span>
                                                                    )}
                                                            </small>
                                                        </>
                                                    )}
                                                </Field>
                                            </div>

                                            {stepFive?.sistema_salud
                                                ?.tiene_discapacidad == 30 ||
                                            (stepFive?.nivel_socioeconomico
                                                ?.con_quien_reside == 24 &&
                                                stepFive?.nivel_socioeconomico
                                                    ?.dependende_economicamente ==
                                                    31) ||
                                            stepFive?.nivel_socioeconomico
                                                ?.puntaje_sisben == 30 ||
                                            (stepFive?.situacion_laboral
                                                ?.ingresos_actuales == 76 &&
                                                stepFive?.sistema_salud
                                                    ?.hace_parte_agremiacion_asociacion_salud ==
                                                    30) ? (
                                                <h6 className="col-lg-12">
                                                    OTROS DOCUMENTOS *
                                                    OBLIGATORIOS
                                                </h6>
                                            ) : (
                                                ""
                                            )}

                                            {stepFive?.sistema_salud
                                                ?.tiene_discapacidad == 30 && (
                                                <div className="col-lg-12 mb-4">
                                                    <Field
                                                        name="certificaciónDiscapacidad"
                                                        defaultValue={
                                                            dataForm?.certificaciónDiscapacidad
                                                        }
                                                    >
                                                        {({ input, meta }) => (
                                                            <>
                                                                <p
                                                                    style={{
                                                                        marginBottom:
                                                                            "-12px",
                                                                    }}
                                                                >
                                                                    Certificación
                                                                    médica que
                                                                    señale
                                                                    existencia
                                                                    de condición
                                                                    de
                                                                    discapacidad:*
                                                                </p>
                                                                {props.values
                                                                    .certificaciónDiscapacidad ? (
                                                                    <div>
                                                                        <div className="files-upload">
                                                                            <p className="text-truncate">
                                                                                {
                                                                                    props
                                                                                        .values
                                                                                        .certificaciónDiscapacidad[0]
                                                                                        .name
                                                                                }
                                                                            </p>
                                                                            <div className="content-buttons">
                                                                                {props
                                                                                    .values
                                                                                    .certificaciónDiscapacidad[0]
                                                                                    .name !==
                                                                                "Sin Archivo" ? (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-primary"
                                                                                        onClick={() =>
                                                                                            showModal(
                                                                                                props
                                                                                                    .values
                                                                                                    ?.certificaciónDiscapacidad[0]
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Ver
                                                                                    </button>
                                                                                ) : (
                                                                                    ""
                                                                                )}

                                                                                <button
                                                                                    className="btn btn-danger ml-1"
                                                                                    onClick={() => {
                                                                                        input.onChange(
                                                                                            ""
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        {props
                                                                            .values
                                                                            .certificaciónDiscapacidad[0]
                                                                            .causal ? (
                                                                            <span className="causal-alert">
                                                                                {
                                                                                    props
                                                                                        .values
                                                                                        .certificaciónDiscapacidad[0]
                                                                                        .causal
                                                                                }
                                                                            </span>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div className="form-group gov-co-form-group">
                                                                        <FileField
                                                                            name="certificaciónDiscapacidad"
                                                                            className="custom-file-input input-file-govco"
                                                                            style={{
                                                                                height: "112px",
                                                                            }}
                                                                            accept="application/pdf"
                                                                        ></FileField>
                                                                        <label className="custom-file-label label-file-govco">
                                                                            <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                            Arrastre
                                                                            aquí
                                                                            su(s)
                                                                            archivo(s)
                                                                            o
                                                                            haga
                                                                            click
                                                                            para
                                                                            añadir.
                                                                        </label>
                                                                    </div>
                                                                )}
                                                                <small className="error-message form-text">
                                                                    {" "}
                                                                    {meta.error &&
                                                                        meta.touched && (
                                                                            <span>
                                                                                {
                                                                                    meta.error
                                                                                }
                                                                            </span>
                                                                        )}
                                                                </small>
                                                            </>
                                                        )}
                                                    </Field>
                                                </div>
                                            )}
                                            {stepFive?.nivel_socioeconomico
                                                ?.con_quien_reside == 24 &&
                                                stepFive?.nivel_socioeconomico
                                                    ?.dependende_economicamente ==
                                                    31 && (
                                                    <div className="col-lg-12 mb-4">
                                                        <Field
                                                            name="declaraciónJuramentadaAdultoMayor"
                                                            defaultValue={
                                                                dataForm?.declaraciónJuramentadaAdultoMayor
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "-12px",
                                                                        }}
                                                                    >
                                                                        Declaración
                                                                        juramentada
                                                                        de
                                                                        tercero
                                                                        ante
                                                                        notario
                                                                        (adulto
                                                                        mayor
                                                                        vive
                                                                        solo y
                                                                        no
                                                                        depende
                                                                        económicamente
                                                                        de
                                                                        nadie):*
                                                                    </p>
                                                                    {props
                                                                        .values
                                                                        .declaraciónJuramentadaAdultoMayor ? (
                                                                        <div>
                                                                            <div className="files-upload">
                                                                                <p className="text-truncate">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .declaraciónJuramentadaAdultoMayor[0]
                                                                                            .name
                                                                                    }
                                                                                </p>
                                                                                <div className="content-buttons">
                                                                                    {props
                                                                                        .values
                                                                                        .declaraciónJuramentadaAdultoMayor[0]
                                                                                        .name !==
                                                                                    "Sin Archivo" ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                showModal(
                                                                                                    props
                                                                                                        .values
                                                                                                        ?.declaraciónJuramentadaAdultoMayor[0]
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Ver
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <button
                                                                                        className="btn btn-danger ml-1"
                                                                                        onClick={() => {
                                                                                            input.onChange(
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {props
                                                                                .values
                                                                                .declaraciónJuramentadaAdultoMayor[0]
                                                                                .causal ? (
                                                                                <span className="causal-alert">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .declaraciónJuramentadaAdultoMayor[0]
                                                                                            .causal
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-group gov-co-form-group">
                                                                            <FileField
                                                                                name="declaraciónJuramentadaAdultoMayor"
                                                                                className="custom-file-input input-file-govco"
                                                                                style={{
                                                                                    height: "112px",
                                                                                }}
                                                                                accept="application/pdf"
                                                                            ></FileField>
                                                                            <label className="custom-file-label label-file-govco">
                                                                                <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                                Arrastre
                                                                                aquí
                                                                                su(s)
                                                                                archivo(s)
                                                                                o
                                                                                haga
                                                                                click
                                                                                para
                                                                                añadir.
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                )}
                                            {stepFive?.nivel_socioeconomico
                                                ?.puntaje_sisben == 30 && (
                                                <div className="col-lg-12 mb-4">
                                                    <Field
                                                        name="certificaciónSisben"
                                                        defaultValue={
                                                            dataForm?.certificaciónSisben
                                                        }
                                                    >
                                                        {({ input, meta }) => (
                                                            <>
                                                                <p
                                                                    style={{
                                                                        marginBottom:
                                                                            "-12px",
                                                                    }}
                                                                >
                                                                    Certificación
                                                                    de SISBÉN :*
                                                                </p>
                                                                {props.values
                                                                    .certificaciónSisben ? (
                                                                    <div>
                                                                        <div className="files-upload">
                                                                            <p className="text-truncate">
                                                                                {
                                                                                    props
                                                                                        .values
                                                                                        .certificaciónSisben[0]
                                                                                        .name
                                                                                }
                                                                            </p>
                                                                            <div className="content-buttons">
                                                                                {props
                                                                                    .values
                                                                                    .certificaciónSisben[0]
                                                                                    .name !==
                                                                                "Sin Archivo" ? (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-primary"
                                                                                        onClick={() =>
                                                                                            showModal(
                                                                                                props
                                                                                                    .values
                                                                                                    ?.certificaciónSisben[0]
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Ver
                                                                                    </button>
                                                                                ) : (
                                                                                    ""
                                                                                )}

                                                                                <button
                                                                                    className="btn btn-danger ml-1"
                                                                                    onClick={() => {
                                                                                        input.onChange(
                                                                                            ""
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        {props
                                                                            .values
                                                                            .certificaciónSisben[0]
                                                                            .causal ? (
                                                                            <span className="causal-alert">
                                                                                {
                                                                                    props
                                                                                        .values
                                                                                        .certificaciónSisben[0]
                                                                                        .causal
                                                                                }
                                                                            </span>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div className="form-group gov-co-form-group">
                                                                        <FileField
                                                                            name="certificaciónSisben"
                                                                            className="custom-file-input input-file-govco"
                                                                            style={{
                                                                                height: "112px",
                                                                            }}
                                                                            accept="application/pdf"
                                                                        ></FileField>
                                                                        <label className="custom-file-label label-file-govco">
                                                                            <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                            Arrastre
                                                                            aquí
                                                                            su(s)
                                                                            archivo(s)
                                                                            o
                                                                            haga
                                                                            click
                                                                            para
                                                                            añadir.
                                                                        </label>
                                                                    </div>
                                                                )}
                                                                <small className="error-message form-text">
                                                                    {" "}
                                                                    {meta.error &&
                                                                        meta.touched && (
                                                                            <span>
                                                                                {
                                                                                    meta.error
                                                                                }
                                                                            </span>
                                                                        )}
                                                                </small>
                                                            </>
                                                        )}
                                                    </Field>
                                                </div>
                                            )}
                                            {stepFive?.situacion_laboral
                                                ?.ingresos_actuales == 76 &&
                                                stepFive?.sistema_salud
                                                    ?.hace_parte_agremiacion_asociacion_salud ==
                                                    30 && (
                                                    <div className="col-lg-12 mb-4">
                                                        <Field
                                                            name="certificaciónAgremiación"
                                                            defaultValue={
                                                                dataForm?.certificaciónAgremiación
                                                            }
                                                        >
                                                            {({
                                                                input,
                                                                meta,
                                                            }) => (
                                                                <>
                                                                    <p
                                                                        style={{
                                                                            marginBottom:
                                                                                "-12px",
                                                                        }}
                                                                    >
                                                                        Certificación
                                                                        de
                                                                        agremiación
                                                                        o
                                                                        asociación
                                                                        que
                                                                        cubre
                                                                        salud
                                                                        (ingresos
                                                                        inferiores
                                                                        1SMMLV)
                                                                        :*
                                                                    </p>
                                                                    {props
                                                                        .values
                                                                        .certificaciónAgremiación ? (
                                                                        <div>
                                                                            <div className="files-upload">
                                                                                <p className="text-truncate">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .certificaciónAgremiación[0]
                                                                                            .name
                                                                                    }
                                                                                </p>
                                                                                <div className="content-buttons">
                                                                                    {props
                                                                                        .values
                                                                                        .certificaciónAgremiación[0]
                                                                                        .name !==
                                                                                    "Sin Archivo" ? (
                                                                                        <button
                                                                                            type="button"
                                                                                            className="btn btn-primary"
                                                                                            onClick={() =>
                                                                                                showModal(
                                                                                                    props
                                                                                                        .values
                                                                                                        ?.documentoDeIdentificación[0]
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                            Ver
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}

                                                                                    <button
                                                                                        className="btn btn-danger ml-1"
                                                                                        onClick={() => {
                                                                                            input.onChange(
                                                                                                ""
                                                                                            );
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                            {props
                                                                                .values
                                                                                .certificaciónAgremiación[0]
                                                                                .causal ? (
                                                                                <span className="causal-alert">
                                                                                    {
                                                                                        props
                                                                                            .values
                                                                                            .certificaciónAgremiación[0]
                                                                                            .causal
                                                                                    }
                                                                                </span>
                                                                            ) : (
                                                                                ""
                                                                            )}
                                                                        </div>
                                                                    ) : (
                                                                        <div className="form-group gov-co-form-group">
                                                                            <FileField
                                                                                name="certificaciónAgremiación"
                                                                                className="custom-file-input input-file-govco"
                                                                                style={{
                                                                                    height: "112px",
                                                                                }}
                                                                                accept="application/pdf"
                                                                            ></FileField>
                                                                            <label className="custom-file-label label-file-govco">
                                                                                <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                                Arrastre
                                                                                aquí
                                                                                su(s)
                                                                                archivo(s)
                                                                                o
                                                                                haga
                                                                                click
                                                                                para
                                                                                añadir.
                                                                            </label>
                                                                        </div>
                                                                    )}
                                                                    <small className="error-message form-text">
                                                                        {" "}
                                                                        {meta.error &&
                                                                            meta.touched && (
                                                                                <span>
                                                                                    {
                                                                                        meta.error
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                    </small>
                                                                </>
                                                            )}
                                                        </Field>
                                                    </div>
                                                )}

                                            {stepFive?.nivel_socioeconomico
                                                ?.hace_parte_listado_censal ==
                                                30 ||
                                            (stepFive?.situacion_laboral
                                                ?.ingresos_actuales == 76 &&
                                                stepFive?.sistema_salud
                                                    ?.hace_parte_agremiacion_asociacion_salud ==
                                                    30) ? (
                                                <h6 className="col-lg-12">
                                                    OTROS DOCUMENTOS OPCIONALES
                                                </h6>
                                            ) : (
                                                ""
                                            )}
                                            {stepFive?.nivel_socioeconomico
                                                ?.hace_parte_listado_censal ==
                                                30 && (
                                                <div className="col-lg-12 mb-4">
                                                    <Field
                                                        name="soporteListadoCensal"
                                                        defaultValue={
                                                            dataForm?.soporteListadoCensal
                                                        }
                                                    >
                                                        {({ input, meta }) => (
                                                            <>
                                                                <p
                                                                    style={{
                                                                        marginBottom:
                                                                            "-12px",
                                                                    }}
                                                                >
                                                                    Soporte
                                                                    Listado
                                                                    censal:
                                                                </p>
                                                                {props.values
                                                                    .soporteListadoCensal ? (
                                                                    <div>
                                                                        <div className="files-upload">
                                                                            <p className="text-truncate">
                                                                                {
                                                                                    props
                                                                                        .values
                                                                                        .soporteListadoCensal[0]
                                                                                        .name
                                                                                }
                                                                            </p>
                                                                            <div className="content-buttons">
                                                                                {props
                                                                                    .values
                                                                                    .soporteListadoCensal[0]
                                                                                    .name !==
                                                                                "Sin Archivo" ? (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-primary"
                                                                                        onClick={() =>
                                                                                            showModal(
                                                                                                props
                                                                                                    .values
                                                                                                    ?.soporteListadoCensal[0]
                                                                                            )
                                                                                        }
                                                                                    >
                                                                                        Ver
                                                                                    </button>
                                                                                ) : (
                                                                                    ""
                                                                                )}

                                                                                <button
                                                                                    className="btn btn-danger ml-1"
                                                                                    onClick={() => {
                                                                                        input.onChange(
                                                                                            ""
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    X
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        {props
                                                                            .values
                                                                            .soporteListadoCensal[0]
                                                                            .causal ? (
                                                                            <span className="causal-alert">
                                                                                {
                                                                                    props
                                                                                        .values
                                                                                        .soporteListadoCensal[0]
                                                                                        .causal
                                                                                }
                                                                            </span>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </div>
                                                                ) : (
                                                                    <div className="form-group gov-co-form-group">
                                                                        <FileField
                                                                            name="soporteListadoCensal"
                                                                            className="custom-file-input input-file-govco"
                                                                            style={{
                                                                                height: "112px",
                                                                            }}
                                                                            accept="application/pdf"
                                                                        ></FileField>
                                                                        <label className="custom-file-label label-file-govco">
                                                                            <span className="govco-icon govco-icon-attached-n color-attach"></span>
                                                                            Arrastre
                                                                            aquí
                                                                            su(s)
                                                                            archivo(s)
                                                                            o
                                                                            haga
                                                                            click
                                                                            para
                                                                            añadir.
                                                                        </label>
                                                                    </div>
                                                                )}
                                                                <small className="error-message form-text">
                                                                    {" "}
                                                                    {meta.error &&
                                                                        meta.touched && (
                                                                            <span>
                                                                                {
                                                                                    meta.error
                                                                                }
                                                                            </span>
                                                                        )}
                                                                </small>
                                                            </>
                                                        )}
                                                    </Field>
                                                </div>
                                            )}
                                            <Field
                                                name="términos"
                                                type="checkbox"
                                            >
                                                {({ input, meta }) => (
                                                    <label
                                                        className="container-check"
                                                        style={{
                                                            margin: "20px",
                                                        }}
                                                    >
                                                        <input
                                                            {...input}
                                                            type="checkbox"
                                                            className="mr-2"
                                                        />
                                                        <span className="checkmark"></span>
                                                        <a
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            href="https://www.culturarecreacionydeporte.gov.co/es/terminos-y-condiciones"
                                                        >
                                                            Acepto términos y
                                                            condiciones
                                                        </a>
                                                        <small className="error-message form-text">
                                                            {meta.error &&
                                                                meta.touched && (
                                                                    <span>
                                                                        {
                                                                            meta.error
                                                                        }
                                                                    </span>
                                                                )}{" "}
                                                        </small>
                                                    </label>
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                )}
                            </FormSpy>
                        </Wizard.Page>
                    </Wizard>
                )}
            />
            {/* {show && (
                <div
                    className="modal"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div
                        className="modal-dialog modal-lg modal-dialog-centered"
                        role="document"
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Vista previa de PDF
                                </h5>
                                <button
                                    type="button"
                                    className="close"
                                    onClick={handleClose}
                                >
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <iframe
                                    id="pdf-preview"
                                    title="pdf-preview"
                                    src={url}
                                    width="760px"
                                    height="800px"
                                ></iframe>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleClose}
                                >
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )} */}
        </>
    );
};

export default BepsForm;
